function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function fireAdRollSegment(segmentId) {
  try {
    if (window.__adroll && typeof __adroll.record_user === "function") {
      __adroll.record_user({
        adroll_segments: segmentId
      });
    }
  } catch (e) {
    // fail silently
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === "plus") {
      if (
        parseInt(this.input.dataset.min) > parseInt(this.input.step) &&
        this.input.value == 0
      ) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (
      this.input.dataset.min === previousValue &&
      event.target.name === "minus"
    ) {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle(
        "disabled",
        parseInt(value) <= parseInt(this.input.min)
      );
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)"
    ).forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    
    $('.menu-drawer__menu-item').removeClass('active');  
    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    
      
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);

    
    
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
    
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    $(".select-error").remove();
    var proceed = true;
    $(".custom-variant-options")
      .find(".select__select")
      .css({ border: "0px solid #d61536" });
    $("variant-selects").parent(".variant-block-container").css({
      border: "0px solid #d61536",
      "border-top-right-radius": "0px",
      "border-top-left-radius": "0px",
    });

    $("variant-selects").each(function () {
      console.log($(this).find("select").val() + ' ddd')
      if ($(this).find("select").val() == "select") {
        proceed = false;
        // $(".custom-variant-options")
        //   .find(".select__select")
        //   .css({ border: "2px solid #d61536" });
        // $("variant-selects")
        //   .parent(".variant-block-container")
        //   .css({ border: "2px solid #d61536", "border-radius": "0px" });
      }
    });
    $("variant-radios").each(function () {
      if ($("variant-radios").find("input:checked").length == 0) {
        proceed = false;
      }
    });

    this.updateOptions();
    this.updateMasterId();
    this.updateMedia();
    if (proceed == false) {
      return;
    } else {
      $("variant-radios").css("pointer-events", "initial");
    }

    this.toggleAddButton(true, "", false);
    //this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    const fieldsets = Array.from(document.querySelectorAll("fieldset"));
    const varselects = Array.from(document.querySelectorAll("variant-selects"));

    var option1 = [];

    fieldsets.forEach((fieldset, index) => {
      if (fieldset.querySelectorAll("input[type='radio']").length > 0) {
        option1.push(
          Array.from(fieldset.querySelectorAll("input")).find(
            (radio) => radio.checked
          ).value
        );
      }

      if (fieldset.querySelectorAll("select").length > 0) {
        option1.push(fieldset.querySelectorAll("select")[0].value);
      }
    });
    varselects.forEach((varselect, index) => {
      if (varselect.querySelectorAll("select").length > 0) {
        option1.push(varselect.querySelectorAll("select")[0].value);
      }
    });
    this.options = option1;
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if ($("custom-slider").length > 0) {
      var count = 0;
      var cindex = 0;

      $(this).parent().addClass("active");
      $(".thumb-slider .swiper-slide:visible").each(function (index) {
        if ($(this).hasClass("active")) {
          cindex = count;
        }
        count++;
      });

      var varid = "";
      if (!this.currentVariant) {
        varid = $('variant-radios[data-option="color"] input:checked').data(
          "var"
        );
        if (
          $('variant-radios[data-option="color"] input:checked').length == 0
        ) {
          return;
        }
      } else {
        varid = this.currentVariant.id;
      }

      if ($('variant-radios[data-option="color"]').length != 0) {
        $('variant-radios[data-option="color"] .form__label').text(
          "Color: " +
            $('variant-radios[data-option="color"] input:checked').val()
        );
      }
      var index = $(".thumb-slider").index($(".swiper-slide.active"));
      $(".product__media-gallery").find(".swiper-slide").hide();
      // $(".product__media-gallery")
      //   .find(".swiper-slide")
      //   .find("a")
      //   .removeAttr("data-fancybox");
      $(".product__media-gallery")
        .find('.swiper-slide[data-color="' + varid + '"]')
        .show();
      // $(".product__media-gallery")
      //   .find('.swiper-slide[data-color="' + varid + '"]')
      //   .find("a")
      //   .attr("data-fancybox", "group");
      var fimg = '';
      if ($('variant-radios[data-option="color"]').length != 0) {
       fimg = "product-thumbnail-" + $('input[name="properties[_Image]"]').data('thumb') + '-' + $('variant-radios[data-option="color"] input:checked').val().toLowerCase().replace(' ','-') + '.jpg';
      }else{
        fimg = "product-thumbnail-" + $('input[name="properties[_Image]"]').data('thumb') + '.jpg';
      }
      $('input[name="properties[_Image]"]').attr("value", "https://43164c-d4.myshopify.com/cdn/shop/files/" + fimg);

      $(".thumb-slider .swiper-slide").removeClass("active");

      $(".thumb-slider .swiper-slide:visible").eq(cindex).addClass("active");
    }
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    // if (disable) {
    //   addButton.setAttribute("disabled", "disabled");
    //   if (text) addButtonText.textContent = text;
    // } else {
    //   addButton.removeAttribute("disabled");
    //   addButtonText.textContent = window.variantStrings.addToCart;
    // }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
 //   addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    var option1 = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
    var option2 = Array.from(
      document.querySelectorAll(".select__select"),
      (select) => select.value
    );
    this.options = option1.concat(option2);
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class CarCover extends HTMLElement {
  constructor() {
    super();
    var this2 = this;
    var curl = $(this2).data("url");
    if ($(this2).data("collectiontype") == "SBS") {
      $(".before-reset").hide();
          $(this2).find(".after-reset").show();
        $(this2).find(".after-reset").css("margin-bottom", "500px");
      $( document ).ready(function() {
          setTimeout(function(){
            $("html, body").animate(
              {
                scrollTop: $(".breadcrumb-wrapper").offset().top - 10,
              },
              800
            );
            setTimeout(function(){
                $(this2).find('.main-collection-accordion-wrapper').eq(0).addClass('active');
                $(this2).find(".after-reset").css("margin-bottom", "50px");
            },1500);
          },800);  
      });
      
    }
    initClickEvents();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    var maintitle = $(this2).data("title");
    var dynamicdiscurl = $(this2).attr("data-descCsvUrl");

    var csvurl = $(this2).data("csvdata");
    var href = new URL(csvurl);
    var random = Math.floor(Math.random() * 100000000);
    href.searchParams.set("v", random);
    csvurl = href.toString();
    var jsonarr = [];

    $.ajax({
      type: "GET",
      url: csvurl,
      dataType: "text",
      success: function (data) {
        var csvData = data;
        let word_array = $.csv.toArrays(csvData);

        for (let index = 1; index < word_array.length; index++) {
          var ob = {};
          ob["category"] = word_array[index][0];
          ob["year"] = word_array[index][1];
          ob["make"] = word_array[index][2];
          ob["model"] = word_array[index][3];
          ob["brand"] = word_array[index][4];
          jsonarr.push(ob);
        }
        setDataInPage(jsonarr);
      },
    });

    function checkImage(make, model, category, type) {
      category = category.toLowerCase().replace(/\s+/g, "-");

      var cmake = make.toLowerCase().replace("make_", "").replace(/\s+/g, "-");
      var cmodel = model
        .toLowerCase()
        .replace("model_", "")
        .replace(/\s+/g, "-");
      var url =
        "//cdn.shopify.com/s/files/1/0699/7816/1398/files/brand-" +
        cmake +
        "-" +
        cmodel +
        "-alt.jpg";
      if (type == "bmc") {
        url =
          "//cdn.shopify.com/s/files/1/0699/7816/1398/files/brand-" +
          cmake +
          "-" +
          category +
          "-alt.jpg";
      }
      if (type == "bm") {
        url =
          "//cdn.shopify.com/s/files/1/0699/7816/1398/files/brand-" +
          cmake +
          "-alt.jpg";
      }
      var s = document.createElement("IMG");
      s.src = url;
      s.onerror = function () {
        if (type == "bmm") {
          checkImage(make, model, category, "bmc");
        }
        if (type == "bmc") {
          checkImage(make, model, category, "bm");
        }
      };
      s.onload = function () {
        $(this2).find(".brand-image").find("img").attr("src", url);
      };
    }

    if (urlParams.has("img")) {
      var url = `https://cdn.shopify.com/s/files/1/0699/7816/1398/files/brand-${urlParams
        .get("img")
        .toLowerCase()}-alt.jpg`;
      var s = document.createElement("IMG");
      s.src = url;
      s.onerror = function () {};
      s.onload = function () {
        $(".brand-image").html(`<img src="${url}" alt="Brand Logo" class="brand-logo">`);
      };

      var url2 = `https://cdn.shopify.com/s/files/1/0699/7816/1398/files/brand-${urlParams
        .get("img")
        .toLowerCase()}.jpg`;
      var s2 = document.createElement("IMG");
      s2.src = url;
      s2.onerror = function () {};
      s2.onload = function () {
        $(".section-landing-description .wrapper").prepend(
          `<img src="${url2}" alt="Brand Logo" class="brand-logo">`
        );
      };
    }
    if (urlParams.has("kw")) {
      document.title = `${urlParams.get(
        "kw"
      )} ${maintitle} – CoverAnything.com`;
      $(".dynamic-title").html(
        "<strong>" + urlParams.get("kw") + "</strong> " + maintitle
      );
    } else {
      //$(this2).find(".currenttag").html("100% Satisfaction Guarantee");
    }
    if (urlParams.has("alt")) {
      $(".main-featured-image").each(function () {
        $(this).attr(
          "alt",
          `${urlParams.get("alt")} ${$(this).attr(
            "data-fabric"
          )} ${maintitle.replace("overs", "over")}`
        );
      });
    }

    if (urlParams.has("desc")) {
      $.ajax({
        type: "GET",
        url: dynamicdiscurl,
        dataType: "text",
        success: function (data) {
          var csvData = data;
          let word_array = $.csv.toArrays(csvData);

          for (let index = 1; index < word_array.length; index++) {
            if (word_array[index][0] == urlParams.get("desc")) {
              $(".custom-collection-content .wrapper").html(
                word_array[index][1]
              );
              if (urlParams.has("img")) {
                var url2 = `https://cdn.shopify.com/s/files/1/0699/7816/1398/files/brand-${urlParams
                  .get("img")
                  .toLowerCase()}.jpg`;
                var s2 = document.createElement("IMG");
                s2.src = url;
                s2.onerror = function () {};
                s2.onload = function () {
                  $(".section-landing-description .wrapper").prepend(
                    `<img src="${url2}" alt="Brand Logo" class="brand-logo">`
                  );
                };
              }
            }
          }
        },
      });
    }

    if (urlParams.has("make") && urlParams.has("model")) {
      $(".product-fit").html(
        `<strong>Custom Fit:</strong> ${urlParams.get("make")} ${urlParams.get(
          "model"
        )}`
      );
      $(".product-fit").show();
    }

    if (urlParams.has("make") && urlParams.has("model") == false) {
      $(".product-fit").html(
        `Choose <strong>${urlParams.get("make")}</strong> Model`
      );
      $(".product-fit").show();
    }

    function setDataInPage(jsonarr) {
      var strpart = $(this2).data("strpart");

      var colltitle = $(this2).data("title");
      var collprotitle = $(this2).data("protitle");

      var years = [];
      $.each(jsonarr, function (index, value) {
        if ($.inArray(value.year, years) === -1) {
          years.push(value.year);
        }
      });
      loadData(years);

      function loadData(years) {
        years.sort();
        years.reverse();
        var stryear =
          '<option value="Select Year" disabled selected>Select Year</option>';
        for (var i = 0; i < years.length; i++) {
          var yy = years[i];
          stryear =
            stryear + `<option value='${yy}'>${yy.split("_")[1]}</option>`;
        }
        $(this2).find(".yearselect").html(stryear);
        $(this2).find(".yearselect").removeAttr("disabled");
        
        $(this2)
          .find(".yearselect")
          .change(function () {
            $(this2).find(".yearselect").val($(this).val());
           // $(this2).find(".amfinder-reset").show();

            $(this2)
              .find(".modelselect")
              .html(
                '<option value="Please Select" disabled selected>Loading..</option>'
              );
            $(this2)
              .find(".makeselect")
              .html(
                '<option value="Please Select" disabled selected>Loading..</option>'
              );

            var makes = [];
            var selyear = $(this).val();
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.make, makes) === -1) {
                if (value.year == selyear) {
                  makes.push(value.make);
                }
              }
            });
            makes.sort();
            var strmake =
              '<option value="Select Make" disabled selected>Select Make</option>';
            for (var i = 0; i < makes.length; i++) {
              var ma = makes[i];
              var valma = ma.replace(".", "");
              valma = valma.replace("'", "");
              valma = valma.replace('"', "");
              strmake =
                strmake +
                `<option value='${valma}'>${ma.split("_")[1]}</option>`;
            }
            $(this2).find(".makeselect").html(strmake);
            $(this2).find(".makeselect").removeAttr("disabled");
            $(this2).find(".input-container").removeClass("active");
            $(this2)
              .find(".makeselect")
              .parents(".input-container")
              .addClass("active");
            $(this2)
              .find(".modelselect")
              .html(
                '<option value="Select Model" disabled selected>Select Model</option>'
              );
            $(this2).find(".modelselect").attr("disabled", true);
          });

        $(this2)
          .find(".makeselect")
          .change(function () {
            $(this2).find(".makeselect").val($(this).val());
            //$(this2).find(".amfinder-reset").show();

            var models = [];
            var selyear = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val();
            var selmake = $(this).val();
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.model, models) === -1) {
                if (value.year == selyear && value.make == selmake) {
                  models.push(value.model);
                }
              }
            });
            models.sort();
            var modelhtml =
              '<option value="Select Model" disabled selected>Select Model</option>';
            for (var i = 0; i < models.length; i++) {
              var mo = models[i];
              var valmo = mo.replace(".", "");
              valmo = valmo.replace("'", "");
              valmo = valmo.replace('"', "");
              modelhtml =
                modelhtml +
                `<option value='${valmo}'>${mo.split("_")[1]}</option>`;
            }
            $(this2).find(".modelselect").html(modelhtml);
            $(this2).find(".modelselect").removeAttr("disabled");
            $(this2).find(".input-container").removeClass("active");
            $(this2)
              .find(".modelselect")
              .parents(".input-container")
              .addClass("active");
          });

        $(this2)
          .find(".modelselect")
          .change(function () {
            $(this2).find(".modelselect").val($(this).val());
            $(this2).find(".search--button").removeAttr("disabled");
            $(this2).find(".input-container").removeClass("active");
          });

        $(this2)
          .find(".modelselect")
          .change(function () {
            $(this2).find(".modelselect").val($(this).val());
            var yearc = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val()
              .replace(".", "")
              .replace("&", "%26")
              .toLowerCase();
            var makec = $(this)
              .parents(".select-wrapper")
              .find(".makeselect")
              .val()
              .replace(".", "")
              .replace("&", "%26")
              .toLowerCase();
            makec = makec.replace("/", "-");
            var modelc = $(this)
              .parents(".select-wrapper")
              .find(".modelselect")
              .val()
              .replace(".", "")
              .replace("&", "%26")
              .toLowerCase();
            var smodelc = modelc.split("/").join("-");
            var strpartn =
              yearc.split(" ").join("-") +
              "+" +
              makec.split(" ").join("-") +
              "+" +
              smodelc.split(" ").join("-");

           // $(this2).find(".amfinder-reset").show();
            $(".before-reset").hide();
            $(this2).find(".after-reset").show();
            $(this2).find(".view-all-cover").hide();
            $(this2).find("html").css("overflow", "auto");

            $(this2).find(".after-reset").css("text-align", "center");
            $(this2)
              .find(".after-reset")
              .html(
                '<img class="collection-loader" style="text-align:center;width:100px;height:100px;margin:10rem auto 5rem;" src="https://cdn.shopify.com/s/files/1/0699/7816/1398/files/tube-spinner.svg"/>'
              );

            loadProductData();
            function loadProductData() {
              fetch("/collections/all/" + strpartn)
                .then((response) => response.text())
                .then((responseText) => {
                  const html = responseText;
                  var elem = new DOMParser()
                    .parseFromString(html, "text/html")
                    .getElementsByClassName("after-reset")[0];

                  if (elem) {
                    var htmlmake = new DOMParser()
                      .parseFromString(html, "text/html")
                      .getElementsByClassName("after-reset")[0].innerHTML;
                    $(this2).find(".after-reset").html(htmlmake);
                    
                    $(this2).find(".after-reset").css("text-align", "initial");
                    $(this2)
                        .find(".after-reset")
                        .css("margin-bottom", "500px");
                    
                    var curyear = $(this2).find(".yearselect").val();
                    var curmake = $(this2).find(".makeselect").val();
                    var curmodel = $(this2).find(".modelselect").val();
                    
                    $(this2)
                      .find(".currenttag")
                      .html(
                        `<strong>${curyear.split("_")[1]} ${
                          curmake.split("_")[1]
                        }  ${curmodel.split("_")[1]}</strong> ${colltitle}`
                      );
                    $(this2).find(".currentcategory").html(colltitle);
                    $(this2).find(".brand-image").find("img").attr("src", '');
                    checkImage(makec, modelc, colltitle, "bmm");
                    document.title = `${curyear.split("_")[1]} ${
                          curmake.split("_")[1]
                        }  ${curmodel.split("_")[1]} ${colltitle} – CoverAnything.com`;

                    $(this2)
                      .find(".currenttagfit")
                      .html(
                        curyear.split("_")[1] +
                          " " +
                          curmake.split("_")[1] +
                          " " +
                          curmodel.split("_")[1]
                      );

                    $(this2).find(".currcolltag").html(collprotitle);

                    console.log(
                      curl +
                        "?year=" +
                        curyear.split("_")[1] +
                        "&make=" +
                        curmake.split("_")[1].replace("&", "%26") +
                        "&model=" +
                        curmodel.split("_")[1].replace("&", "%26")
                    );

                    window.history.replaceState(
                      {},
                      null,
                      curl +
                        "?year=" +
                        curyear.split("_")[1] +
                        "&make=" +
                        curmake.split("_")[1].replace("&", "%26") +
                        "&model=" +
                        curmodel.split("_")[1].replace("&", "%26")
                    );

                    fireAdRollSegment("9cb5aecd");

                    $("html, body").animate(
                      {
                        scrollTop: $(".breadcrumb-wrapper").offset().top -10,
                      },
                      1000
                    );
                    setTimeout(function(){
                        $(this2).find('.main-collection-accordion-wrapper').eq(0).addClass('active');
                      $(this2)
                        .find(".after-reset")
                        .css("margin-bottom", "50px");
                    },1500);
                  } else {
                    //loadProductData();
                  }

                  initClickEvents();
                })
                .catch((error) => {
                  //loadProductData();
                });
            }
          });

        var yeartag = "";
        var maketag = "";
        var modeltag = "";

        let searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has("year")) {
          yeartag = searchParams.get("year");
        }
        if (searchParams.has("make")) {
          maketag = searchParams.get("make");
        }
        if (searchParams.has("model")) {
          modeltag = searchParams.get("model");
        }

        if (yeartag != "" && maketag != "" && maketag != "") {
          if (yeartag != "") {
            $(this2)
              .find(".yearselect")
              .val("YEAR_" + yeartag);
          }

          if (maketag != "") {
           // $(this2).find(".amfinder-reset").show();

            $(this2)
              .find(".modelselect")
              .html(
                '<option value="Please Select" disabled selected>Loading..</option>'
              );
            $(this2)
              .find(".makeselect")
              .html(
                '<option value="Please Select" disabled selected>Loading..</option>'
              );

            var makes = [];
            var yearnow = "YEAR_" + yeartag;
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.make, makes) === -1) {
                if (value.year == yearnow) {
                  makes.push(value.make);
                }
              }
            });
            makes.sort();
            var strmake =
              '<option value="Select Make" disabled selected>Select Make</option>';
            for (var i = 0; i < makes.length; i++) {
              var ma = makes[i];
              var valma = ma.replace(".", "");
              valma = valma.replace("'", "");
              valma = valma.replace('"', "");
              
              strmake =
                strmake +
                `<option value='${valma}'>${ma.split("_")[1]}</option>`;
            }
            $(this2).find(".makeselect").html(strmake);
            $(this2).find(".makeselect").removeAttr("disabled");
            $(this2)
              .find(".makeselect")
              .val("MAKE_" + maketag);
            $(this2)
              .find(".makeselect")
              .change(function () {
                $(this2).find(".makeselect").val($(this).val());
              //  $(this2).find(".amfinder-reset").show();
                console.log($(this).val());
                var models = [];
                var selyear = $(this)
                  .parents(".select-wrapper")
                  .find(".yearselect")
                  .val();

                var selmake = $(this).val();
                $.each(jsonarr, function (index, value) {
                  if ($.inArray(value.model, models) === -1) {
                    if (value.year == selyear && value.make == selmake) {
                      console.log(value.year);
                      console.log(value.make);
                      models.push(value.model);
                    }
                  }
                });
                models.sort();
                console.log(models);

                var modelhtml =
                  '<option value="Select Model" disabled selected>Select Model</option>';
                for (var i = 0; i < models.length; i++) {
                  var mo = models[i];
                  var valmo = mo.replace(".", "");
                  valmo = valmo.replace("'", "");
                  valmo = valmo.replace('"', "");
                  modelhtml =
                    modelhtml +
                    `<option value='${valmo}'>${mo.split("_")[1]}</option>`;
                }
                $(this2).find(".modelselect").html(modelhtml);
                $(this2).find(".modelselect").removeAttr("disabled");
                $(this2).find(".input-container").removeClass("active");
                $(this2)
                  .find(".modelselect")
                  .parents(".input-container")
                  .addClass("active");
              });
          }

          if (modeltag != "") {
            $(this2)
              .find(".modelselect")
              .html(
                '<option value="Please Select" disabled selected>Loading..</option>'
              );
           // $(this2).find(".amfinder-reset").show();
            var models = [];

            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.model, models) === -1) {
                var yearnow = "YEAR_" + yeartag;
                var makenow = "MAKE_" + maketag;
                var cmakenow = value.make.replace("'", "");
                cmakenow = cmakenow.replace('"', "");
                //cmakenow = cmakenow.replace('%26', "&");
                if (value.year == yearnow && cmakenow == makenow) {
                  models.push(value.model);
                }
              }
            });
            models.sort();
            var modelhtml =
              '<option value="Select Model" disabled selected>Select Model</option>';
            for (var i = 0; i < models.length; i++) {
              var mo = models[i];
              var valmo = mo.replace(".", "");
              valmo = valmo.replace("'", "");
              valmo = valmo.replace('"', ""); 
              modelhtml =
                modelhtml +
                `<option value='${valmo}'>${mo.split("_")[1]}</option>`;
            }
            $(this2).find(".modelselect").html(modelhtml);
            $(this2).find(".modelselect").removeAttr("disabled");
            $(this2)
              .find(".modelselect")
              .val("MODEL_" + modeltag);

            var yearc = "Year_" + yeartag.replace(".", "");
            var makec = "Make_" + maketag.replace(".", "");
            makec = makec.replace("/", "-");
            // makec = makec.replace("&", "%26");
            var modelc = "Model_" + modeltag.replace(".", "");
            modelc = modelc.split("/").join("-");
            // modelc = modelc.replace("&", "%26");
            var partn =
              yearc.split(" ").join("-").toLowerCase() +
              "+" +
              makec.split(" ").join("-").toLowerCase() +
              "+" +
              modelc.split(" ").join("-").toLowerCase();

            var curyear = $(this2).find(".yearselect").val();
            var curmake = $(this2).find(".makeselect").val();
            var curmodel = $(this2).find(".modelselect").val();
            $(this2)
              .find(".currenttag")
              .html(
                `<strong>${curyear.split("_")[1]} ${curmake.split("_")[1]} ${
                  curmodel.split("_")[1]
                }</strong> ${colltitle}`
              );
            $(this2).find(".currentcategory").html(colltitle);

            checkImage(makec, modelc, colltitle, "bmm");

            $(this2)
              .find(".currenttagfit")
              .html(
                curyear.split("_")[1] +
                  " " +
                  curmake.split("_")[1] +
                  " " +
                  curmodel.split("_")[1]
              );

            $(this2).find(".currcolltag").html(collprotitle);

            $(this2).find(".after-reset").css("text-align", "center");
            $(this2)
              .find(".after-reset")
              .html(
                '<img class="collection-loader" style="text-align:center;width:100px;height:100px;margin:10rem auto 5rem;" src="https://cdn.shopify.com/s/files/1/0699/7816/1398/files/tube-spinner.svg"/>'
              );

            var tagsmatch = false;
            var matchyear = "YEAR_" + yeartag;
            var matchmake = "MAKE_" + maketag;
            var matchmodel = "MODEL_" + modeltag;
            if (
              localStorage.getItem("year") !== null &&
              localStorage.getItem("make") !== null &&
              localStorage.getItem("model") !== null
            ) {
              if (
                matchyear.toUpperCase() ==
                  localStorage.getItem("year").toUpperCase() &&
                matchmake.toUpperCase() ==
                  localStorage.getItem("make").toUpperCase() &&
                matchmodel.toUpperCase() ==
                  localStorage.getItem("model").toUpperCase()
              ) {
                tagsmatch = true;
              }
            }

            if (
              localStorage.getItem("afterdata") != null &&
              localStorage.getItem("afterdata") != "" &&
              tagsmatch == true
            ) {
              $(this2)
                .find(".after-reset")
                .html(localStorage.getItem("afterdata"));

              $(this2).find(".after-reset").css("text-align", "initial");
              console.log(Number(localStorage.getItem("scrolltop")));

              var curyear = $(this2).find(".yearselect").val();
              var curmake = $(this2).find(".makeselect").val();
              var curmodel = $(this2).find(".modelselect").val();
              $(this2)
                .find(".currenttag")
                .html(
                  `<strong>${curyear.split("_")[1]} ${curmake.split("_")[1]}  ${
                    curmodel.split("_")[1]
                  }</strong> ${colltitle}`
                );
               document.title = `${curyear.split("_")[1]} ${
                          curmake.split("_")[1]
                        }  ${curmodel.split("_")[1]} ${colltitle} – CoverAnything.com`;
              $(this2).find(".currentcategory").html(colltitle);

              checkImage(makec, modelc, colltitle, "bmm");

              $(this2)
                .find(".currenttagfit")
                .html(
                  curyear.split("_")[1] +
                    " " +
                    curmake.split("_")[1] +
                    " " +
                    curmodel.split("_")[1]
                );

              $(this2).find(".currcolltag").html(collprotitle);

              initClickEvents();
            } else {
              $(this2).find(".after-reset").show();
              loadDataProduct();
              function loadDataProduct() {
                fetch("/collections/all/" + partn)
                  .then((response) => response.text())
                  .then((responseText) => {
                    const html = responseText;
                    var elem = new DOMParser()
                      .parseFromString(html, "text/html")
                      .getElementsByClassName("after-reset")[0];
                    if (elem) {
                      var htmlmake = new DOMParser()
                        .parseFromString(html, "text/html")
                        .getElementsByClassName("after-reset")[0].innerHTML;
                      $(this2).find(".after-reset").html(htmlmake);
                      $(this2)
                        .find(".after-reset")
                        .css("text-align", "initial");
                       $(this2)
                        .find(".after-reset")
                        .css("margin-bottom", "500px");

                      var curyear = $(this2).find(".yearselect").val();
                      var curmake = $(this2).find(".makeselect").val();
                      var curmodel = $(this2).find(".modelselect").val();

                      $(this2)
                        .find(".currenttag")
                        .html(
                          `<strong>${curyear.split("_")[1]} ${
                            curmake.split("_")[1]
                          }  ${curmodel.split("_")[1]}</strong> ${colltitle}`
                        );
                      $(this2).find(".currentcategory").html(colltitle);
                      checkImage(makec, modelc, colltitle, "bmm");

                      $(this2)
                        .find(".currenttagfit")
                        .html(
                          curyear.split("_")[1] +
                            " " +
                            curmake.split("_")[1] +
                            " " +
                            curmodel.split("_")[1]
                        );

                      $(this2).find(".currcolltag").html(collprotitle);
                      
                      document.title = `${curyear.split("_")[1]} ${
                          curmake.split("_")[1]
                        }  ${curmodel.split("_")[1]} ${colltitle} – CoverAnything.com`;

                      window.history.replaceState(
                        {},
                        null,
                        curl +
                          "?year=" +
                          yeartag +
                          "&make=" +
                          maketag.replace("&", "%26") +
                          "&model=" +
                          modeltag.replace("&", "%26")
                      );

                      fireAdRollSegment("9cb5aecd");

                      $("html, body").animate(
                        {
                          scrollTop: $(".breadcrumb-wrapper").offset().top -10,
                        },
                        1000
                      );
                      setTimeout(function(){
                          $(this2).find('.main-collection-accordion-wrapper').eq(0).addClass('active');
                          $(this2)
                            .find(".after-reset")
                            .css("margin-bottom", "50px");
                      },1500);

                      initClickEvents();
                    } else {
                      loadDataProduct();
                    }
                  })
                  .catch((error) => {
                    loadDataProduct();
                  });
              }
            }

            if (yeartag != "" && maketag != "" && modeltag != "") {
             // $(this2).find(".amfinder-reset").show();
              $(".before-reset").hide();
              $(this2).find(".after-reset").show();
              $(this2).find(".view-all-cover").hide();
              var curyear = $(this2).find(".yearselect").val();
              var curmake = $(this2).find(".makeselect").val();
              var curmodel = $(this2).find(".modelselect").val();
              $(this2)
                .find(".currenttag")
                .html(
                  `<strong>${curyear.split("_")[1]} ${curmake.split("_")[1]}  ${
                    curmodel.split("_")[1]
                  }</strong> ${colltitle}`
                );
              $(this2).find(".currentcategory").html(colltitle);
              checkImage(makec, modelc, colltitle, "bmm");

              $(this2)
                .find(".currenttagfit")
                .html(
                  curyear.split("_")[1] +
                    " " +
                    curmake.split("_")[1] +
                    " " +
                    curmodel.split("_")[1]
                );
              $(this2).find(".currcolltag").html(collprotitle);

              document.title = `${curyear.split("_")[1]} ${
                          curmake.split("_")[1]
                        }  ${curmodel.split("_")[1]} ${colltitle} – CoverAnything.com`;

              window.scrollTo(0, Number(localStorage.getItem("scrolltop")));
              localStorage.clear();
            } else {
              // $(this2).find(".currenttag").html("100% Satisfaction Guarantee");
              $(this2).find(".view-all-cover").show();
              $(this2).find(".after-reset").hide();
              $(".before-reset").show();
            //  $(this2).find(".amfinder-reset").hide();
            }
            $(".before-reset").css("opacity", 1);
          }
          window.addEventListener("beforeunload", function (e) {
            localStorage.setItem("afterdata", $(".after-reset").html());
            localStorage.setItem(
              "scrolltop",
              document.documentElement.scrollTop
            );
            localStorage.setItem("year", $(this2).find(".yearselect").val());
            localStorage.setItem("make", $(this2).find(".makeselect").val());
            localStorage.setItem("model", $(this2).find(".modelselect").val());
          });
          document.addEventListener("visibilitychange", () => {
            localStorage.setItem("afterdata", $(".after-reset").html());
            localStorage.setItem(
              "scrolltop",
              document.documentElement.scrollTop
            );
            localStorage.setItem("year", $(this2).find(".yearselect").val());
            localStorage.setItem("make", $(this2).find(".makeselect").val());
            localStorage.setItem("model", $(this2).find(".modelselect").val());
          });

          initClickEvents();

          $(".before-reset").css("opacity", 1);

          var swiper = new Swiper(".swiper-category-slider", {
            slidesPerView: "auto",
            spaceBetween: 30,
          });
        } else {
          $(this2).find(".view-all-cover").show();
          $(this2).find(".after-reset").hide();
          $(".before-reset").show();
          $(this2).find(".amfinder-reset").hide();
          $(".before-reset").css("opacity", 1);
          $(this2).find(".input-container").removeClass("active");
          $(this2).find(".yearselect").parents(".input-container").addClass("active");
        }
      }

      // var d = new Date();

      // if (d.getDay() == 4) {
      //   d.setDate(d.getDate() + 7);
      //   $("#sale-ends-1").text(d.getMonth() + 1 + "/" + d.getDate());
      //   $(".sale_end").text(
      //     "*Sale Ends" + " " + (d.getMonth() + 1) + "/" + d.getDate()
      //   );
      // } else if (d.getDay() == 5) {
      //   d.setDate(d.getDate() + 6);
      //   $("#sale-ends-1").text(d.getMonth() + 1 + "/" + d.getDate());
      //   $(".sale_end").text(
      //     "*Sale Ends" + " " + (d.getMonth() + 1) + "/" + d.getDate()
      //   );
      // } else if (d.getDay() == 6) {
      //   d.setDate(d.getDate() + 5);
      //   $("#sale-ends-1").text(d.getMonth() + 1 + "/" + d.getDate());
      //   $(".sale_end").text(
      //     "*Sale Ends" + " " + (d.getMonth() + 1) + "/" + d.getDate()
      //   );
      // } else if (d.getDay() == 0) {
      //   d.setDate(d.getDate() + 4);
      //   $("#sale-ends-1").text(d.getMonth() + 1 + "/" + d.getDate());
      //   $(".sale_end").text(
      //     "*Sale Ends" + " " + (d.getMonth() + 1) + "/" + d.getDate()
      //   );
      // } else if (d.getDay() == 1) {
      //   d.setDate(d.getDate() + 3);
      //   $("#sale-ends-1").text(d.getMonth() + 1 + "/" + d.getDate());
      //   $(".sale_end").text(
      //     "*Sale Ends" + " " + (d.getMonth() + 1) + "/" + d.getDate()
      //   );
      // } else if (d.getDay() == 2) {
      //   d.setDate(d.getDate() + 2);
      //   $("#sale-ends-1").text(d.getMonth() + 1 + "/" + d.getDate());
      //   $(".sale_end").text(
      //     "*Sale Ends" + " " + (d.getMonth() + 1) + "/" + d.getDate()
      //   );
      // } else if (d.getDay() == 3) {
      //   d.setDate(d.getDate() + 1);
      //   $("#sale-ends-1").text(d.getMonth() + 1 + "/" + d.getDate());
      //   $(".sale_end").text(
      //     "*Sale Ends" + " " + (d.getMonth() + 1) + "/" + d.getDate()
      //   );
      // }
    }
    function initClickEvents() {
      $(".show_more_popup")
        .unbind()
        .click(function () {
          $(".mini-popup").show();
          $("html").css({ "overflow-x": "hidden", "overflow-y": "hidden" });
        });
      $(".btn-cancel")
        .unbind()
        .click(function () {
          $(".mini-popup").hide();
          $("html").css({ "overflow-x": "hidden", "overflow-y": "auto" });
        });
      $(".button-cover")
        .unbind()
        .click(function () {
          $(".mini-popup").show();
          $("html").css({ "overflow-x": "hidden", "overflow-y": "hidden" });
        });
      $(".amfinder-reset").click(function () {
        window.location.href = curl;
      });
      $(".custom-compare-button").click(function () {
        $(this)
          .parents(".main-collection-accordion-wrapper")
          .find(".compare-popup")
          .find(".custom-product-card")
          .addClass("active");
        $(this)
          .parents(".main-collection-accordion-wrapper")
          .find(".compare-popup")
          .find(".custom-product-card")
          .show();
        $(this)
          .parents(".main-collection-accordion-wrapper")
          .find(".compare-popup")
          .show();
        $(this)
          .parents(".main-collection-accordion-wrapper")
          .find(".compare-popup")
          .addClass("active");
      });

      $(this2)
        .find(".collection-main-accordion-header")
        .click(function () {
          $(this).parent().toggleClass("active");
        });

      $(".remove-button")
        .unbind()
        .click(function () {
          var visibleDivCount = $(this)
            .parents(".mini-popup-compare")
            .find(".custom-product-card")
            .filter(function () {
              return $(this).css("display") !== "none";
            }).length;

          $(this).parents(".custom-product-card").hide();
          var cvisibleDivCount = $(this)
            .parents(".mini-popup-compare")
            .find(".custom-product-card")
            .filter(function () {
              return $(this).css("display") !== "none";
            }).length;
          if (cvisibleDivCount == 0) {
            $(".main-mini-popup").removeClass("active");
            $(".main-mini-popup").hide();
          }
        });

      $(this2)
        .find(".custom-product-color-item")
        .click(function () {
          $(this)
            .parents(".custom-product-color-container")
            .find(".custom-product-color-item")
            .removeClass("active");
          $(this).addClass("active");
          $(this)
            .parents(".custom-featured-product-media")
            .find(".custom-main-product-media a img")
            .attr("src", $(this).data("image"));
        });

      $(".show_more_less_swtach")
        .unbind()
        .click(function () {
          $(this)
            .parent(".custom-product-color-container")
            .toggleClass("active-tab");
          $(this)
            .parents(".custom-product-item-bottom")
            .toggleClass("active-tab");
        });

      $(".show_more_less")
        .unbind()
        .click(function () {
          $(this)
            .parents(".custom-featured-product-description")
            .toggleClass("active");
          $(this).toggleClass("active");
        });

      $(this2)
        .find(".collection-main-accordion-header")
        .unbind()
        .click(function () {
          $(this)
            .parent(".main-collection-accordion-wrapper")
            .toggleClass("active");
        });
      $(this2)
        .find(".category-products")
        .click(function () {
          $(this).next().toggle();
          $(this).children(".header-box").toggleClass("opened");
        });
      $(this2)
        .find(".readmore")
        .on("click", function () {
          var $content = $(this).parent();
          var isExpanded = $content.hasClass("expanded");

          if (isExpanded) {
            $content.removeClass("expanded");
            $(this).text("Read More");
          } else {
            $content.addClass("expanded");
            $(this).text("Read Less");
          }
        });
      $(".custom-featured-description")
        .unbind()
        .click(function () {
          $(".show_more_less").click();
        });

      $(".boat-popup-key").click(function () {
        $(".abbreviation-popup").show();
        $(".abbreviation-popup").addClass("active");
      });
    }
  }
}

customElements.define("car-cover", CarCover);

// class FilterCover extends HTMLElement {
//   constructor() {
//     super();
//     var this2 = this;
//     $(document).ready(function () {
//       var url_string = window.location.href;
//       var url = new URL(url_string);
//       var make = url.searchParams.get("make");
//       var model = url.searchParams.get("model");
//       var year = url.searchParams.get("year");
//       var csvurl = $(this2).data("csvfile");
//       var maintitle = $(this2).data("title");
//       var handle = $(this2).data("url");
//       var dynamicdiscurl = $(this2).attr("data-descCsvUrl");
//       var jsonarr = [];

//       $(this2).find(".yearselect").attr("disabled", "true");
//       $.ajax({
//         type: "GET",
//         url: csvurl,
//         dataType: "text",
//         success: function (data) {
//           var csvData = data;
//           let word_array = $.csv.toArrays(csvData);

//           for (let index = 1; index < word_array.length; index++) {
//             var ob = {};
//             ob["category"] = word_array[index][0];
//             ob["year"] = word_array[index][1];
//             ob["make"] = word_array[index][2];
//             ob["model"] = word_array[index][3];
//             ob["title"] = word_array[index][4];
//             ob["images"] = word_array[index][5];
//             ob["instock"] = word_array[index][6];
//             ob["price"] = word_array[index][7];
//             ob["compprice"] = word_array[index][8];
//             ob["tags"] = word_array[index][9];
//             jsonarr.push(ob);
//           }
//           setSelectTags(jsonarr);
//           $(this2).find(".buttons-container").show();
//         },
//       });

//       function setSelectTags(jsonarr) {
//         var hasyear = false;
//         var hasmake = false;
//         var hasmodel = false;
//         var namestr = "";

//         const queryString = window.location.search;
//         const urlParams = new URLSearchParams(queryString);
//         $.each(jsonarr, function (index, value) {
//           if (urlParams.has("year")) {
//             var yeartag = "YEAR_" + urlParams.get("year").toUpperCase();
//             if (value.year.toUpperCase() == yeartag) {
//               hasyear = true;
//             }
//           }
//         });

//         if (urlParams.has("img")) {
//           var url = `https://cdn.shopify.com/s/files/1/0699/7816/1398/files/brand-${urlParams
//             .get("img")
//             .toLowerCase()}-alt.jpg`;
//           var s = document.createElement("IMG");
//           s.src = url;
//           s.onerror = function () {};
//           s.onload = function () {
//             $(".brand-image").html(`<img src="${url}" alt="Brand Logo" class="brand-logo">`);
//           };
//         }
//         if (urlParams.has("kw")) {
//           document.title = `${urlParams.get(
//             "kw"
//           )} ${maintitle} – CoverAnything.com`;
//           $(".dynamic-title strong").html(urlParams.get("kw") + " ");
//         }
//         if (urlParams.has("alt")) {
//           $(".main-featured-image").each(function () {
//             $(this).attr(
//               "alt",
//               `${urlParams.get("alt")} ${$(this).attr(
//                 "data-fabric"
//               )} ${maintitle.replace("overs", "over")}`
//             );
//           });
//         }

//         if (urlParams.has("desc")) {
//           $.ajax({
//             type: "GET",
//             url: dynamicdiscurl,
//             dataType: "text",
//             success: function (data) {
//               var csvData = data;
//               let word_array = $.csv.toArrays(csvData);

//               for (let index = 1; index < word_array.length; index++) {
//                 if (word_array[index][0] == urlParams.get("desc")) {
//                   $(".custom-collection-content .wrapper").html(
//                     word_array[index][1]
//                   );

//                   if (urlParams.has("img")) {
//                     var url = `https://cdn.shopify.com/s/files/1/0699/7816/1398/files/brand-${urlParams
//                       .get("img")
//                       .toLowerCase()}.jpg`;
//                     var s = document.createElement("IMG");
//                     s.src = url;
//                     s.onerror = function () {};
//                     s.onload = function () {
//                       $(".section-landing-description .wrapper").prepend(
//                         `<img src="${url}" alt="Brand Logo" class="brand-logo">`
//                       );
//                     };
//                   }
//                 }
//               }
//             },
//           });
//         }

//         if (urlParams.has("make") && urlParams.has("model")) {
//           $(".product-fit").html(
//             `<strong>Fit:</strong> ${urlParams.get("make")} ${urlParams.get(
//               "model"
//             )}`
//           );
//           $(".product-fit").show();
//         }

//         if (urlParams.has("make") && urlParams.has("model") == false) {
//           $(".product-fit").html(
//             `Custom <strong>${urlParams.get("make")}</strong> Fit`
//           );
//           $(".product-fit").show();
//         }

//         $.each(jsonarr, function (index, value) {
//           if (urlParams.has("make")) {
//             var maketag = "MAKE_" + urlParams.get("make").toUpperCase();
//             if (value.make.toUpperCase() == maketag) {
//               hasmake = true;
//             }
//           }
//         });

//         $.each(jsonarr, function (index, value) {
//           if (urlParams.has("model")) {
//             var modeltag = "MODEL_" + urlParams.get("model").toUpperCase();
//             if (value.model.toUpperCase() == modeltag) {
//               hasmodel = true;
//             }
//           }
//         });

//         if (hasmodel == true && hasmake == true) {
//           $(this2).find(".yearselectbox").css("order", 3);
//           $(this2).find(".makeselectbox").css("order", 1);
//           $(this2).find(".modelselectbox").css("order", 2);
//           namestr = urlParams.get("make") + " " + urlParams.get("model");
//           var maketag = "MAKE_" + urlParams.get("make").toUpperCase();
//           var modeltag = "MODEL_" + urlParams.get("model").toUpperCase();

//           var makes = [];
//           var selyear = $(this).val();
//           $.each(jsonarr, function (index, value) {
//             if ($.inArray(value.make, makes) === -1) {
//               makes.push(value.make);
//             }
//           });
//           makes.sort();
//           var strmake =
//             '<option value="Select Make" disabled>Select Make</option>';
//           for (var i = 0; i < makes.length; i++) {
//             var ma = makes[i];
//             var selected = "";
//             if (ma.toUpperCase() == maketag) {
//               selected = "selected";
//             }
//             strmake =
//               strmake +
//               `<option value='${ma.replace(".", "")}' ${selected}>${
//                 ma.split("_")[1]
//               }</option>`;
//           }
//           $(this2).find(".makeselect").html(strmake);
//           $(this2).find(".makeselect").removeAttr("disabled");
//           $(this2).find(".finder-box").removeClass("active");
//           $(this2)
//             .find(".makeselect")
//             .parents(".finder-box")
//             .addClass("active");
//           var models = [];
//           $.each(jsonarr, function (index, value) {
//             if ($.inArray(value.model, models) === -1) {
//               if (value.make.toUpperCase() == maketag) {
//                 models.push(value.model);
//               }
//             }
//           });
//           models.sort();
//           var modelhtml =
//             '<option value="Select Model" disabled>Select Model</option>';
//           for (var i = 0; i < models.length; i++) {
//             var mo = models[i];
//             var selected = "";
//             if (mo.toUpperCase() == modeltag) {
//               selected = "selected";
//             }
//             modelhtml =
//               modelhtml +
//               `<option value='${mo.replace(".", "")}' ${selected}>${
//                 mo.split("_")[1]
//               }</option>`;
//           }
//           $(this2).find(".modelselect").html(modelhtml);
//           $(this2).find(".modelselect").removeAttr("disabled");
//           $(this2).find(".finder-box").removeClass("active");
//           $(this2)
//             .find(".modelselect")
//             .parents(".finder-box")
//             .addClass("active");
//           var years = [];

//           var datasearch = {};

//           $.each(jsonarr, function (index, value) {
//             if ($.inArray(value.year, years) === -1) {
//               if (
//                 value.make.toUpperCase() == maketag &&
//                 value.model.toUpperCase() == modeltag
//               ) {
//                 years.push(value.year);
//               }
//             }
//           });

//           years.sort();

//           var yearhtml =
//             '<option value="Select Year" disabled selected>Select Year</option>';
//           for (var i = 0; i < years.length; i++) {
//             var ye = years[i];
//             yearhtml =
//               yearhtml +
//               `<option value='${ye.replace(".", "")}'>${
//                 ye.split("_")[1]
//               }</option>`;
//           }
//           $(this2).find(".yearselect").html(yearhtml);
//           $(this2).find(".yearselect").removeAttr("disabled");
//           $(this2).find(".finder-box").removeClass("active");
//           $(this2)
//             .find(".yearselect")
//             .parents(".finder-box")
//             .addClass("active");
//           $(this2)
//             .find(".makeselect")
//             .change(function () {
//               namestr = $(this).val().split("_")[1];
//               $(this2).find(".makeselect").val($(this).val());
//               var models = [];
//               var selmake = $(this).val();
//               $.each(jsonarr, function (index, value) {
//                 if ($.inArray(value.model, models) === -1) {
//                   if (value.make == selmake) {
//                     models.push(value.model);
//                   }
//                 }
//               });
//               models.sort();
//               var modelhtml =
//                 '<option value="Select Model" disabled selected>Select Model</option>';
//               for (var i = 0; i < models.length; i++) {
//                 var mo = models[i];
//                 var valmo = mo.replace(".", "");
//                 valmo = valmo.replace("'", "");
//                 valmo = valmo.replace('"', "");
//                 modelhtml =
//                   modelhtml +
//                   `<option value='${valmo}'>${mo.split("_")[1]}</option>`;
//               }
//               $(this2).find(".modelselect").html(modelhtml);
//               $(this2).find(".modelselect").removeAttr("disabled");
//               $(this2).find(".finder-box").removeClass("active");
//               $(this2)
//                 .find(".modelselect")
//                 .parents(".finder-box")
//                 .addClass("active");
//               var yearhtml =
//                 '<option value="Select Year" disabled selected>Select Year</option>';
//               $(this2).find(".yearselect").html(yearhtml);
//               $(this2).find(".yearselect").attr("disabled", true);
//               $(this2).find(".finder-box").removeClass("active");
//               $(this2)
//                 .find(".yearselect")
//                 .parents(".finder-box")
//                 .addClass("active");
//             });

//           $(this2)
//             .find(".modelselect")
//             .change(function () {
//               $(this2).find(".modelselect").val($(this).val());
//               var years = [];
//               var datasearch = {};
//               var selmake = $(this)
//                 .parents(".select-wrapper")
//                 .find(".makeselect")
//                 .val();
//               var selmodel = $(this).val();
//               namestr =
//                 selmake.split("_")[1] + " " + $(this).val().split("_")[1];
//               $.each(jsonarr, function (index, value) {
//                 if ($.inArray(value.year, years) === -1) {
//                   if (
//                     value.make.toUpperCase() == selmake.toUpperCase() &&
//                     value.model.toUpperCase() == selmodel.toUpperCase()
//                   ) {
//                     years.push(value.year);
//                   }
//                 }
//               });

//               years.sort();

//               var yearhtml =
//                 '<option value="Select Year" disabled selected>Select Year</option>';
//               for (var i = 0; i < years.length; i++) {
//                 var ye = years[i];
//                 yearhtml =
//                   yearhtml +
//                   `<option value='${ye.replace(".", "")}'>${
//                     ye.split("_")[1]
//                   }</option>`;
//               }
//               $(this2).find(".yearselect").html(yearhtml);
//               $(this2).find(".yearselect").removeAttr("disabled");
//               $(this2).find(".finder-box").removeClass("active");
//               $(this2)
//                 .find(".yearselect")
//                 .parents(".finder-box")
//                 .addClass("active");
//             });

//           $(this2)
//             .find(".yearselect")
//             .change(function () {
//               $(this2).find(".yearselect").val($(this).val());
//               var yearc = $(this)
//                 .parents(".select-wrapper")
//                 .find(".yearselect")
//                 .val()
//                 .replace(".", "")
//                 .replace("&", "%26")
//                 .toLowerCase();
//               var makec = $(this)
//                 .parents(".select-wrapper")
//                 .find(".makeselect")
//                 .val()
//                 .replace(".", "")
//                 .replace("&", "%26")
//                 .toLowerCase();
//               makec = makec.replace("/", "-");
//               var modelc = $(this)
//                 .parents(".select-wrapper")
//                 .find(".modelselect")
//                 .val()
//                 .replace(".", "")
//                 .replace("&", "%26")
//                 .toLowerCase();
//               var smodelc = modelc.split("/").join("-");

//               var strpartn =
//                 yearc.split(" ").join("-") +
//                 "+" +
//                 makec.split(" ").join("-") +
//                 "+" +
//                 smodelc.split(" ").join("-");

//               var redurl =
//                 handle +
//                 "?year=" +
//                 yearc.split("_")[1] +
//                 "&make=" +
//                 makec.split("_")[1] +
//                 "&model=" +
//                 modelc.split("_")[1];
//               localStorage.clear();
//               window.location.href = redurl;
//             });
//         }

//         if (hasyear == true && hasmodel == true) {
//           namestr = urlParams.get("year") + " " + urlParams.get("model");
//           $(this2).find(".yearselectbox").css("order", 1);
//           $(this2).find(".modelselectbox").css("order", 2);
//           $(this2).find(".makeselectbox").css("order", 3);

//           var yeartag = "YEAR_" + urlParams.get("year").toUpperCase();
//           var modeltag = "MODEL_" + urlParams.get("model").toUpperCase();

//           var years = [];
//           $.each(jsonarr, function (index, value) {
//             if ($.inArray(value.year, years) === -1) {
//               years.push(value.year);
//             }
//           });

//           years.sort();
//           years.reverse();
//           var stryear =
//             '<option value="Select Year" disabled>Select Year</option>';
//           for (var i = 0; i < years.length; i++) {
//             var yy = years[i];
//             var selected = "";
//             if (yy.toUpperCase() == yeartag) {
//               selected = "selected";
//             }
//             stryear =
//               stryear +
//               `<option value='${yy}' ${selected}>${yy.split("_")[1]}</option>`;
//           }
//           $(this2).find(".yearselect").html(stryear);
//           $(this2).find(".yearselect").removeAttr("disabled");
//           $(this2).find(".finder-box").removeClass("active");
//           $(this2)
//             .find(".yearselect")
//             .parents(".finder-box")
//             .addClass("active");
//           var models = [];

//           $.each(jsonarr, function (index, value) {
//             if ($.inArray(value.model, models) === -1) {
//               if (value.year.toUpperCase() == yeartag) {
//                 models.push(value.model);
//               }
//             }
//           });
//           models.sort();
//           var modelhtml =
//             '<option value="Select Model" disabled >Select Model</option>';
//           for (var i = 0; i < models.length; i++) {
//             var mo = models[i];
//             var selected = "";
//             if (mo.toUpperCase() == modeltag) {
//               selected = "selected";
//             }
//             modelhtml =
//               modelhtml +
//               `<option value='${mo.replace(".", "")}' ${selected}>${
//                 mo.split("_")[1]
//               }</option>`;
//           }
//           $(this2).find(".modelselect").html(modelhtml);
//           $(this2).find(".modelselect").removeAttr("disabled");
//           $(this2).find(".finder-box").removeClass("active");
//           $(this2)
//             .find(".modelselect")
//             .parents(".finder-box")
//             .addClass("active");
//           $(this2)
//             .find(".yearselect")
//             .change(function () {
//               namestr = $(this).val().split("_")[1];
//               $(this2).find(".yearselect").val($(this).val());
//               var models = [];
//               var selyear = $(this).val();
//               $.each(jsonarr, function (index, value) {
//                 if ($.inArray(value.model, models) === -1) {
//                   if (value.year == selyear) {
//                     models.push(value.model);
//                   }
//                 }
//               });
//               models.sort();
//               var modelhtml =
//                 '<option value="Select Model" disabled selected>Select Model</option>';
//               for (var i = 0; i < models.length; i++) {
//                 var mo = models[i];
//                 var valmo = mo.replace(".", "");
//                 valmo = valmo.replace("'", "");
//                 valmo = valmo.replace('"', "");
//                 modelhtml =
//                   modelhtml +
//                   `<option value='${valmo}'>${mo.split("_")[1]}</option>`;
//               }
//               $(this2).find(".modelselect").html(modelhtml);
//               $(this2).find(".modelselect").removeAttr("disabled");
//               $(this2).find(".finder-box").removeClass("active");
//               $(this2)
//                 .find(".modelselect")
//                 .parents(".finder-box")
//                 .addClass("active");
//               var makehtml =
//                 '<option value="Select Make" disabled selected>Select Make</option>';
//               $(this2).find(".makeselect").html(makehtml);
//               $(this2).find(".makeselect").attr("disabled", true);
//             });

//           $(this2)
//             .find(".modelselect")
//             .change(function () {
//               $(this2).find(".modelselect").val($(this).val());
//               var makes = [];

//               var datasearch = {};
//               var selyear = $(this)
//                 .parents(".select-wrapper")
//                 .find(".yearselect")
//                 .val();
//               var selmodel = $(this).val();
//               namestr =
//                 selyear.split("_")[1] + " " + $(this).val().split("_")[1];
//               $.each(jsonarr, function (index, value) {
//                 if ($.inArray(value.make, makes) === -1) {
//                   if (
//                     value.year.toUpperCase() == selyear.toUpperCase() &&
//                     value.model.toUpperCase() == selmodel.toUpperCase()
//                   ) {
//                     makes.push(value.make);
//                   }
//                 }
//               });

//               makes.sort();

//               var makehtml =
//                 '<option value="Select Make" disabled selected>Select Make</option>';
//               for (var i = 0; i < makes.length; i++) {
//                 var ma = makes[i];
//                 makehtml =
//                   makehtml +
//                   `<option value='${ma.replace(".", "")}'>${
//                     ma.split("_")[1]
//                   }</option>`;
//               }
//               $(this2).find(".makeselect").html(makehtml);
//               $(this2).find(".makeselect").removeAttr("disabled");
//               $(this2).find(".finder-box").removeClass("active");
//               $(this2)
//                 .find(".makeselect")
//                 .parents(".finder-box")
//                 .addClass("active");
//             });

//           var makes = [];

//           var datasearch = {};

//           var found = false;

//           $.each(jsonarr, function (index, value) {
//             if ($.inArray(value.make, makes) === -1) {
//               if (
//                 value.year.toUpperCase() == yeartag &&
//                 value.model.toUpperCase() == modeltag
//               ) {
//                 makes.push(value.make);

//                 found = true;
//               }
//             }
//           });

//           makes.sort();

//           var makehtml =
//             '<option value="Select Make" disabled selected>Select Make</option>';
//           for (var i = 0; i < makes.length; i++) {
//             var ma = makes[i];
//             makehtml =
//               makehtml +
//               `<option value='${ma.replace(".", "")}'>${
//                 ma.split("_")[1]
//               }</option>`;
//           }
//           $(this2).find(".makeselect").html(makehtml);
//           $(this2).find(".makeselect").removeAttr("disabled");

//           $(this2)
//             .find(".makeselect")
//             .change(function () {
//               $(this2).find(".makeselect").val($(this).val());
//               var yearc = $(this)
//                 .parents(".select-wrapper")
//                 .find(".yearselect")
//                 .val()
//                 .replace(".", "")
//                 .replace("&", "%26")
//                 .toLowerCase();
//               var makec = $(this)
//                 .parents(".select-wrapper")
//                 .find(".makeselect")
//                 .val()
//                 .replace(".", "")
//                 .replace("&", "%26")
//                 .toLowerCase();
//               makec = makec.replace("/", "-");
//               var modelc = $(this)
//                 .parents(".select-wrapper")
//                 .find(".modelselect")
//                 .val()
//                 .replace(".", "")
//                 .replace("&", "%26")
//                 .toLowerCase();
//               var smodelc = modelc.split("/").join("-");
//               var strpartn =
//                 yearc.split(" ").join("-") +
//                 "+" +
//                 makec.split(" ").join("-") +
//                 "+" +
//                 smodelc.split(" ").join("-");

//               var redurl =
//                 handle +
//                 "?year=" +
//                 yearc.split("_")[1] +
//                 "&make=" +
//                 makec.split("_")[1] +
//                 "&model=" +
//                 modelc.split("_")[1];
//               localStorage.clear();
//               window.location.href = redurl;
//             });
//         }

//         if (hasyear == true && hasmake == true) {
//           namestr = urlParams.get("year") + " " + urlParams.get("make");
//           $(this2).find(".yearselectbox").css("order", 1);
//           $(this2).find(".makeselectbox").css("order", 2);
//           $(this2).find(".modelselectbox").css("order", 3);

//           var yeartag = "YEAR_" + urlParams.get("year").toUpperCase();
//           var maketag = "MAKE_" + urlParams.get("make").toUpperCase();

//           var years = [];
//           $.each(jsonarr, function (index, value) {
//             if ($.inArray(value.year, years) === -1) {
//               years.push(value.year);
//             }
//           });

//           years.sort();
//           years.reverse();
//           var stryear =
//             '<option value="Select Year" disabled>Select Year</option>';
//           for (var i = 0; i < years.length; i++) {
//             var yy = years[i];
//             var selected = "";
//             if (yy.toUpperCase() == yeartag) {
//               selected = "selected";
//             }
//             stryear =
//               stryear +
//               `<option value='${yy}' ${selected}>${yy.split("_")[1]}</option>`;
//           }
//           $(this2).find(".yearselect").html(stryear);
//           $(this2).find(".yearselect").removeAttr("disabled");
//           $(this2).find(".finder-box").removeClass("active");
//           $(this2)
//             .find(".yearselect")
//             .parents(".finder-box")
//             .addClass("active");
//           var makes = [];

//           $.each(jsonarr, function (index, value) {
//             if ($.inArray(value.make, makes) === -1) {
//               if (value.year.toUpperCase() == yeartag) {
//                 makes.push(value.make);
//               }
//             }
//           });
//           makes.sort();
//           var makehtml =
//             '<option value="Select Make" disabled >Select Make</option>';
//           for (var i = 0; i < makes.length; i++) {
//             var ma = makes[i];
//             var selected = "";
//             if (ma.toUpperCase() == maketag) {
//               selected = "selected";
//             }
//             makehtml =
//               makehtml +
//               `<option value='${ma.replace(".", "")}' ${selected}>${
//                 ma.split("_")[1]
//               }</option>`;
//           }
//           $(this2).find(".makeselect").html(makehtml);
//           $(this2).find(".makeselect").removeAttr("disabled");
//           $(this2).find(".finder-box").removeClass("active");
//           $(this2)
//             .find(".makeselect")
//             .parents(".finder-box")
//             .addClass("active");
//           $(this2)
//             .find(".yearselect")
//             .change(function () {
//               namestr = $(this).val().split("_")[1];
//               $(this2).find(".yearselect").val($(this).val());
//               var makes = [];

//               var datasearch = {};
//               var selyear = $(this)
//                 .parents(".select-wrapper")
//                 .find(".yearselect")
//                 .val();

//               $.each(jsonarr, function (index, value) {
//                 if ($.inArray(value.make, makes) === -1) {
//                   if (value.year.toUpperCase() == selyear.toUpperCase()) {
//                     makes.push(value.make);
//                   }
//                 }
//               });

//               makes.sort();

//               var makehtml =
//                 '<option value="Select Make" disabled selected>Select Make</option>';
//               for (var i = 0; i < makes.length; i++) {
//                 var ma = makes[i];
//                 makehtml =
//                   makehtml +
//                   `<option value='${ma.replace(".", "")}'>${
//                     ma.split("_")[1]
//                   }</option>`;
//               }
//               $(this2).find(".makeselect").html(makehtml);
//               $(this2).find(".makeselect").removeAttr("disabled");
//               $(this2).find(".finder-box").removeClass("active");
//               $(this2)
//                 .find(".makeselect")
//                 .parents(".finder-box")
//                 .addClass("active");
//               var modelhtml =
//                 '<option value="Select Model" disabled selected>Select Model</option>';
//               $(this2).find(".modelselect").html(modelhtml);
//               $(this2).find(".modelselect").attr("disabled", true);
//             });

//           $(this2)
//             .find(".makeselect")
//             .change(function () {
//               $(this2).find(".makeselect").val($(this).val());
//               var models = [];
//               var selyear = $(this)
//                 .parents(".select-wrapper")
//                 .find(".yearselect")
//                 .val();
//               var selmake = $(this).val();
//               namestr =
//                 selyear.split("_")[1] + " " + $(this).val().split("_")[1];
//               $.each(jsonarr, function (index, value) {
//                 if ($.inArray(value.model, models) === -1) {
//                   if (value.year == selyear && value.make == selmake) {
//                     models.push(value.model);
//                   }
//                 }
//               });
//               models.sort();
//               var modelhtml =
//                 '<option value="Select Model" disabled selected>Select Model</option>';
//               for (var i = 0; i < models.length; i++) {
//                 var mo = models[i];
//                 var valmo = mo.replace(".", "");
//                 valmo = valmo.replace("'", "");
//                 valmo = valmo.replace('"', "");
//                 modelhtml =
//                   modelhtml +
//                   `<option value='${valmo}'>${mo.split("_")[1]}</option>`;
//               }
//               $(this2).find(".modelselect").html(modelhtml);
//               $(this2).find(".modelselect").removeAttr("disabled");
//               $(this2).find(".finder-box").removeClass("active");
//               $(this2)
//                 .find(".modelselect")
//                 .parents(".finder-box")
//                 .addClass("active");
//             });

//           var models = [];

//           var datasearch = {};

//           var found = false;

//           $.each(jsonarr, function (index, value) {
//             if ($.inArray(value.model, models) === -1) {
//               if (
//                 value.year.toUpperCase() == yeartag &&
//                 value.make.toUpperCase() == maketag
//               ) {
//                 models.push(value.model);

//                 found = true;
//               }
//             }
//           });

//           models.sort();

//           var modelhtml =
//             '<option value="Select Model" disabled selected>Select Model</option>';
//           for (var i = 0; i < models.length; i++) {
//             var mo = models[i];
//             modelhtml =
//               modelhtml +
//               `<option value='${mo.replace(".", "")}'>${
//                 mo.split("_")[1]
//               }</option>`;
//           }
//           $(this2).find(".modelselect").html(modelhtml);
//           $(this2).find(".modelselect").removeAttr("disabled");
//           $(this2).find(".finder-box").removeClass("active");
//           $(this2)
//             .find(".modelselect")
//             .parents(".finder-box")
//             .addClass("active");
//           $(this2)
//             .find(".modelselect")
//             .change(function () {
//               $(this2).find(".modelselect").val($(this).val());
//               var yearc = $(this)
//                 .parents(".select-wrapper")
//                 .find(".yearselect")
//                 .val()
//                 .replace(".", "")
//                 .replace("&", "%26")
//                 .toLowerCase();
//               var makec = $(this)
//                 .parents(".select-wrapper")
//                 .find(".makeselect")
//                 .val()
//                 .replace(".", "")
//                 .replace("&", "%26")
//                 .toLowerCase();
//               makec = makec.replace("/", "-");
//               var modelc = $(this)
//                 .parents(".select-wrapper")
//                 .find(".modelselect")
//                 .val()
//                 .replace(".", "")
//                 .replace("&", "%26")
//                 .toLowerCase();
//               var smodelc = modelc.split("/").join("-");
//               var strpartn =
//                 yearc.split(" ").join("-") +
//                 "+" +
//                 makec.split(" ").join("-") +
//                 "+" +
//                 smodelc.split(" ").join("-");

//               var redurl =
//                 handle +
//                 "?year=" +
//                 yearc.split("_")[1] +
//                 "&make=" +
//                 makec.split("_")[1] +
//                 "&model=" +
//                 modelc.split("_")[1];
//               localStorage.clear();
//               window.location.href = redurl;
//             });
//         }

//         if (hasyear == false && hasmodel == false && hasmake == false) {
//           namestr = maintitle;
//           $(this2).find(".yearselectbox").css("order", 1);
//           $(this2).find(".makeselectbox").css("order", 2);
//           $(this2).find(".modelselectbox").css("order", 3);

//           var datasearch = jsonarr[0];
//           var years = [];
//           $.each(jsonarr, function (index, value) {
//             if ($.inArray(value.year, years) === -1) {
//               years.push(value.year);
//             }
//           });
//           years.sort();
//           years.reverse();
//           var stryear =
//             '<option value="Select Year" disabled selected>Select Year</option>';
//           for (var i = 0; i < years.length; i++) {
//             var yy = years[i];
//             stryear =
//               stryear + `<option value='${yy}'>${yy.split("_")[1]}</option>`;
//           }
//           $(this2).find(".yearselect").html(stryear);
//           $(this2).find(".yearselect").removeAttr("disabled");
//           $(this2).find(".finder-box").removeClass("active");
//           $(this2)
//             .find(".yearselect")
//             .parents(".finder-box")
//             .addClass("active");
//           $(this2)
//             .find(".yearselect")
//             .change(function () {
//               $(this2).find(".yearselect").val($(this).val());
//               //$(this2).find(".amfinder-reset").show();

//               $(this2)
//                 .find(".modelselect")
//                 .html(
//                   '<option value="Please Select" disabled selected>Loading..</option>'
//                 );
//               $(this2)
//                 .find(".makeselect")
//                 .html(
//                   '<option value="Please Select" disabled selected>Loading..</option>'
//                 );

//               var makes = [];
//               var selyear = $(this).val();
//               $.each(jsonarr, function (index, value) {
//                 if ($.inArray(value.make, makes) === -1) {
//                   if (value.year == selyear) {
//                     makes.push(value.make);
//                   }
//                 }
//               });
//               makes.sort();
//               var strmake =
//                 '<option value="Select Make" disabled selected>Select Make</option>';
//               for (var i = 0; i < makes.length; i++) {
//                 var ma = makes[i];
//                 var valma = ma.replace(".", "");
//                 valma = valma.replace("'", "");
//                 valma = valma.replace('"', "");
//                 strmake =
//                   strmake +
//                   `<option value='${valma}'>${ma.split("_")[1]}</option>`;
//               }
//               $(this2).find(".makeselect").html(strmake);
//               $(this2).find(".makeselect").removeAttr("disabled");
//               $(this2).find(".finder-box").removeClass("active");
//               $(this2)
//                 .find(".makeselect")
//                 .parents(".finder-box")
//                 .addClass("active");
//               $(this2)
//                 .find(".modelselect")
//                 .html(
//                   '<option value="Select Model" disabled selected>Select Model</option>'
//                 );
//               $(this2).find(".modelselect").attr("disabled", true);
//             });
//           $(this2)
//             .find(".makeselect")
//             .change(function () {
//               $(this2).find(".makeselect").val($(this).val());
//              // $(this2).find(".amfinder-reset").show();

//               var models = [];
//               var selyear = $(this)
//                 .parents(".select-wrapper")
//                 .find(".yearselect")
//                 .val();
//               var selmake = $(this).val();
//               $.each(jsonarr, function (index, value) {
//                 if ($.inArray(value.model, models) === -1) {
//                   if (value.year == selyear && value.make == selmake) {
//                     models.push(value.model);
//                   }
//                 }
//               });
//               models.sort();
//               var modelhtml =
//                 '<option value="Select Model" disabled selected>Select Model</option>';
//               for (var i = 0; i < models.length; i++) {
//                 var mo = models[i];
//                 var valmo = mo.replace(".", "");
//                 valmo = valmo.replace("'", "");
//                 valmo = valmo.replace('"', "");
//                 modelhtml =
//                   modelhtml +
//                   `<option value='${valmo}'>${mo.split("_")[1]}</option>`;
//               }
//               $(this2).find(".modelselect").html(modelhtml);
//               $(this2).find(".modelselect").removeAttr("disabled");
//               $(this2).find(".finder-box").removeClass("active");
//               $(this2)
//                 .find(".modelselect")
//                 .parents(".finder-box")
//                 .addClass("active");
//             });

//           $(this2)
//             .find(".modelselect")
//             .change(function () {
//               $(this2).find(".modelselect").val($(this).val());
//               $(this2).find(".search--button").removeAttr("disabled");
//             });

//           //$(".search--button").click(function ()
//           $(this2)
//             .find(".modelselect")
//             .change(function () {
//               $(this2).find(".modelselect").val($(this).val());
//               var yearc = $(this)
//                 .parents(".select-wrapper")
//                 .find(".yearselect")
//                 .val()
//                 .replace(".", "")
//                 .replace("&", "%26")
//                 .toLowerCase();
//               var makec = $(this)
//                 .parents(".select-wrapper")
//                 .find(".makeselect")
//                 .val()
//                 .replace(".", "")
//                 .replace("&", "%26")
//                 .toLowerCase();
//               makec = makec.replace("/", "-");
//               var modelc = $(this)
//                 .parents(".select-wrapper")
//                 .find(".modelselect")
//                 .val()
//                 .replace(".", "")
//                 .replace("&", "%26")
//                 .toLowerCase();
//               var smodelc = modelc.split("/").join("-");
//               var redurl =
//                 handle +
//                 "?year=" +
//                 yearc.split("_")[1] +
//                 "&make=" +
//                 makec.split("_")[1] +
//                 "&model=" +
//                 modelc.split("_")[1];

//               localStorage.clear();
//               window.location.href = redurl;
//             });
//         }

//         if (hasyear == true && hasmodel == false && hasmake == false) {
//           namestr = maintitle;
//           $(this2).find(".yearselectbox").css("order", 1);
//           $(this2).find(".makeselectbox").css("order", 2);
//           $(this2).find(".modelselectbox").css("order", 3);

//           var yeartag = "YEAR_" + urlParams.get("year").toUpperCase();

//           var found = false;
//           var datasearch = {};
//           var years = [];
//           $.each(jsonarr, function (index, value) {
//             if ($.inArray(value.year, years) === -1) {
//               years.push(value.year);
//             }
//           });

//           years.sort();
//           years.reverse();
//           var stryear =
//             '<option value="Select Year" disabled>Select Year</option>';
//           for (var i = 0; i < years.length; i++) {
//             var yy = years[i];
//             var selected = "";
//             if (yy.toUpperCase() == yeartag) {
//               selected = "selected";
//             }
//             stryear =
//               stryear +
//               `<option value='${yy}' ${selected}>${yy.split("_")[1]}</option>`;
//           }
//           $(this2).find(".yearselect").html(stryear);
//           $(this2).find(".yearselect").removeAttr("disabled");
//           $(this2).find(".finder-box").removeClass("active");
//           $(this2)
//             .find(".yearselect")
//             .parents(".finder-box")
//             .addClass("active");
//           $(this2)
//             .find(".modelselect")
//             .html(
//               '<option value="Please Select" disabled selected>Loading..</option>'
//             );
//           $(this2)
//             .find(".makeselect")
//             .html(
//               '<option value="Please Select" disabled selected>Loading..</option>'
//             );

//           var makes = [];
//           var selyear = yeartag;
//           $.each(jsonarr, function (index, value) {
//             if ($.inArray(value.make, makes) === -1) {
//               if (value.year == selyear) {
//                 makes.push(value.make);
//                 if (found == false) {
//                   found = true;
//                 }
//               }
//             }
//           });
//           makes.sort();
//           var strmake =
//             '<option value="Select Make" disabled selected>Select Make</option>';
//           for (var i = 0; i < makes.length; i++) {
//             var ma = makes[i];
//             var valma = ma.replace(".", "");
//             valma = valma.replace("'", "");
//             valma = valma.replace('"', "");
//             strmake =
//               strmake + `<option value='${valma}'>${ma.split("_")[1]}</option>`;
//           }
//           $(this2).find(".makeselect").html(strmake);
//           $(this2).find(".makeselect").removeAttr("disabled");
//           $(this2).find(".finder-box").removeClass("active");
//           $(this2)
//             .find(".makeselect")
//             .parents(".finder-box")
//             .addClass("active");
//           $(this2)
//             .find(".modelselect")
//             .html(
//               '<option value="Select Model" disabled selected>Select Model</option>'
//             );
//           $(this2).find(".modelselect").attr("disabled", true);

//           $(this2)
//             .find(".yearselect")
//             .change(function () {
//               $(this2).find(".yearselect").val($(this).val());
//               var makes = [];

//               var datasearch = {};
//               var selyear = $(this)
//                 .parents(".select-wrapper")
//                 .find(".yearselect")
//                 .val();

//               $.each(jsonarr, function (index, value) {
//                 if ($.inArray(value.make, makes) === -1) {
//                   if (value.year.toUpperCase() == selyear.toUpperCase()) {
//                     makes.push(value.make);
//                   }
//                 }
//               });

//               makes.sort();

//               var makehtml =
//                 '<option value="Select Make" disabled selected>Select Make</option>';
//               for (var i = 0; i < makes.length; i++) {
//                 var ma = makes[i];
//                 makehtml =
//                   makehtml +
//                   `<option value='${ma.replace(".", "")}'>${
//                     ma.split("_")[1]
//                   }</option>`;
//               }
//               $(this2).find(".makeselect").html(makehtml);
//               $(this2).find(".makeselect").removeAttr("disabled");
//               $(this2).find(".finder-box").removeClass("active");
//               $(this2)
//                 .find(".makeselect")
//                 .parents(".finder-box")
//                 .addClass("active");
//               var modelhtml =
//                 '<option value="Select Model" disabled selected>Select Model</option>';
//               $(this2).find(".modelselect").html(modelhtml);
//               $(this2).find(".modelselect").attr("disabled", true);
//             });

//           $(this2)
//             .find(".makeselect")
//             .change(function () {
//               $(this2).find(".makeselect").val($(this).val());
//              // $(this2).find(".amfinder-reset").show();

//               var models = [];
//               var selyear = $(this)
//                 .parents(".select-wrapper")
//                 .find(".yearselect")
//                 .val();
//               var selmake = $(this).val();

//               $.each(jsonarr, function (index, value) {
//                 if ($.inArray(value.model, models) === -1) {
//                   if (value.year == selyear && value.make == selmake) {
//                     models.push(value.model);
//                   }
//                 }
//               });
//               models.sort();
//               var modelhtml =
//                 '<option value="Select Model" disabled selected>Select Model</option>';
//               for (var i = 0; i < models.length; i++) {
//                 var mo = models[i];
//                 var valmo = mo.replace(".", "");
//                 valmo = valmo.replace("'", "");
//                 valmo = valmo.replace('"', "");
//                 modelhtml =
//                   modelhtml +
//                   `<option value='${valmo}'>${mo.split("_")[1]}</option>`;
//               }
//               $(this2).find(".modelselect").html(modelhtml);
//               $(this2).find(".modelselect").removeAttr("disabled");
//               $(this2).find(".finder-box").removeClass("active");
//               $(this2)
//                 .find(".modelselect")
//                 .parents(".finder-box")
//                 .addClass("active");
//             });

//           $(this2)
//             .find(".modelselect")
//             .change(function () {
//               $(this2).find(".modelselect").val($(this).val());
//               $(this2).find(".search--button").removeAttr("disabled");
//             });

//           $(this2)
//             .find(".modelselect")
//             .change(function () {
//               $(this2).find(".modelselect").val($(this).val());
//               var yearc = $(this)
//                 .parents(".select-wrapper")
//                 .find(".yearselect")
//                 .val()
//                 .replace(".", "")
//                 .replace("&", "%26")
//                 .toLowerCase();
//               var makec = $(this)
//                 .parents(".select-wrapper")
//                 .find(".makeselect")
//                 .val()
//                 .replace(".", "")
//                 .replace("&", "%26")
//                 .toLowerCase();
//               makec = makec.replace("/", "-");
//               var modelc = $(this)
//                 .parents(".select-wrapper")
//                 .find(".modelselect")
//                 .val()
//                 .replace(".", "")
//                 .replace("&", "%26")
//                 .toLowerCase();
//               var smodelc = modelc.split("/").join("-");
//               var redurl =
//                 handle +
//                 "?year=" +
//                 yearc.split("_")[1] +
//                 "&make=" +
//                 makec.split("_")[1] +
//                 "&model=" +
//                 modelc.split("_")[1];

//               localStorage.clear();
//               window.location.href = redurl;
//             });
//         }

//         if (hasyear == false && hasmodel == true && hasmake == false) {
//           $(this2).find(".makeselectbox").css("order", 2);
//           $(this2).find(".modelselectbox").css("order", 1);
//           $(this2).find(".yearselectbox").css("order", 3);

//           var modeltag = "MODEL_" + urlParams.get("model").toUpperCase();

//           var models = [];

//           $.each(jsonarr, function (index, value) {
//             if ($.inArray(value.model, models) === -1) {
//               models.push(value.model);
//             }
//           });
//           models.sort();
//           var modelhtml =
//             '<option value="Select Model" disabled >Select Model</option>';
//           for (var i = 0; i < models.length; i++) {
//             var mo = models[i];
//             var selected = "";
//             if (mo.toUpperCase() == modeltag) {
//               selected = "selected";
//             }
//             modelhtml =
//               modelhtml +
//               `<option value='${mo.replace(".", "")}' ${selected}>${
//                 mo.split("_")[1]
//               }</option>`;
//           }
//           $(this2).find(".modelselect").html(modelhtml);
//           $(this2).find(".modelselect").removeAttr("disabled");
//           $(this2).find(".finder-box").removeClass("active");
//           $(this2)
//             .find(".modelselect")
//             .parents(".finder-box")
//             .addClass("active");
//           var makes = [];

//           var datasearch = {};

//           var found = false;

//           $.each(jsonarr, function (index, value) {
//             if ($.inArray(value.make, makes) === -1) {
//               if (value.model.toUpperCase() == modeltag) {
//                 makes.push(value.make);
//                 if (found == false) {
//                   found = true;
//                 }
//               }
//             }
//           });

//           makes.sort();

//           var makehtml =
//             '<option value="Select Make" disabled selected>Select Make</option>';
//           for (var i = 0; i < makes.length; i++) {
//             var ma = makes[i];
//             makehtml =
//               makehtml +
//               `<option value='${ma.replace(".", "")}'>${
//                 ma.split("_")[1]
//               }</option>`;
//           }
//           $(this2).find(".makeselect").html(makehtml);
//           $(this2).find(".makeselect").removeAttr("disabled");
//           $(this2).find(".finder-box").removeClass("active");
//           $(this2)
//             .find(".makeselect")
//             .parents(".finder-box")
//             .addClass("active");
//           $(this2)
//             .find(".yearselect")
//             .html(
//               '<option value="Select Year" disabled selected>Select Year</option>'
//             );
//           $(this2).find(".yearselect").attr("disabled", true);

//           $(this2)
//             .find(".modelselect")
//             .change(function () {
//               $(this2).find(".modelselect").val($(this).val());
//               var makes = [];

//               var datasearch = {};

//               var selmodel = $(this).val();
//               namestr = $(this).val().split("_")[1];
//               $.each(jsonarr, function (index, value) {
//                 if ($.inArray(value.make, makes) === -1) {
//                   if (value.model.toUpperCase() == selmodel.toUpperCase()) {
//                     makes.push(value.make);
//                   }
//                 }
//               });

//               makes.sort();

//               var makehtml =
//                 '<option value="Select Make" disabled selected>Select Make</option>';
//               for (var i = 0; i < makes.length; i++) {
//                 var ma = makes[i];
//                 makehtml =
//                   makehtml +
//                   `<option value='${ma.replace(".", "")}'>${
//                     ma.split("_")[1]
//                   }</option>`;
//               }
//               $(this2).find(".makeselect").html(makehtml);
//               $(this2).find(".makeselect").removeAttr("disabled");
//               $(this2).find(".finder-box").removeClass("active");
//               $(this2)
//                 .find(".makeselect")
//                 .parents(".finder-box")
//                 .addClass("active");
//               var yearhtml =
//                 '<option value="Select Year" disabled selected>Select Year</option>';
//               $(this2).find(".yearselect").html(yearhtml);
//               $(this2).find(".yearselect").attr("disabled", true);
//             });

//           $(this2)
//             .find(".makeselect")
//             .change(function () {
//               $(this2).find(".makeselect").val($(this).val());
//               //$(this2).find(".amfinder-reset").show();
//               var years = [];
//               var selmodel = $(this)
//                 .parents(".select-wrapper")
//                 .find(".modelselect")
//                 .val();
//               var selmake = $(this).val();
//               namestr =
//                 $(this).val().split("_")[1] + " " + modeltag.split("_")[1];
//               $.each(jsonarr, function (index, value) {
//                 if ($.inArray(value.year, years) === -1) {
//                   if (
//                     value.model.toUpperCase() == selmodel.toUpperCase() &&
//                     value.make.toUpperCase() == selmake.toUpperCase()
//                   ) {
//                     years.push(value.year);
//                   }
//                 }
//               });
//               years.sort();
//               var yearhtml =
//                 '<option value="Select Year" disabled selected>Select Year</option>';
//               for (var i = 0; i < years.length; i++) {
//                 var ye = years[i];
//                 var valyear = ye.replace(".", "");
//                 valyear = valyear.replace("'", "");
//                 valyear = valyear.replace('"', "");
//                 yearhtml =
//                   yearhtml +
//                   `<option value='${valyear}'>${ye.split("_")[1]}</option>`;
//               }
//               $(this2).find(".yearselect").html(yearhtml);
//               $(this2).find(".yearselect").removeAttr("disabled");
//               $(this2).find(".finder-box").removeClass("active");
//               $(this2)
//                 .find(".yearselect")
//                 .parents(".finder-box")
//                 .addClass("active");
//             });

//           $(this2)
//             .find(".yearselect")
//             .change(function () {
//               $(this2).find(".yearselect").val($(this).val());
//               var yearc = $(this)
//                 .parents(".select-wrapper")
//                 .find(".yearselect")
//                 .val()
//                 .replace(".", "")
//                 .replace("&", "%26")
//                 .toLowerCase();
//               var makec = $(this)
//                 .parents(".select-wrapper")
//                 .find(".makeselect")
//                 .val()
//                 .replace(".", "")
//                 .replace("&", "%26")
//                 .toLowerCase();
//               makec = makec.replace("/", "-");
//               var modelc = $(this)
//                 .parents(".select-wrapper")
//                 .find(".modelselect")
//                 .val()
//                 .replace(".", "")
//                 .replace("&", "%26")
//                 .toLowerCase();
//               var smodelc = modelc.split("/").join("-");
//               var redurl =
//                 handle +
//                 "?year=" +
//                 yearc.split("_")[1] +
//                 "&make=" +
//                 makec.split("_")[1] +
//                 "&model=" +
//                 modelc.split("_")[1];

//               localStorage.clear();
//               window.location.href = redurl;
//             });
//         }

//         if (hasyear == false && hasmodel == false && hasmake == true) {
//           $(this2).find(".makeselectbox").css("order", 1);
//           $(this2).find(".modelselectbox").css("order", 2);
//           $(this2).find(".yearselectbox").css("order", 3);

//           var maketag = "MAKE_" + urlParams.get("make").toUpperCase();

//           var makes = [];

//           $.each(jsonarr, function (index, value) {
//             if ($.inArray(value.make, makes) === -1) {
//               makes.push(value.make);
//             }
//           });
//           makes.sort();
//           var strmake =
//             '<option value="Select Make" disabled>Select Make</option>';
//           for (var i = 0; i < makes.length; i++) {
//             var ma = makes[i];
//             var selected = "";
//             if (ma.toUpperCase() == maketag) {
//               selected = "selected";
//             }
//             strmake =
//               strmake +
//               `<option value='${ma.replace(".", "")}' ${selected}>${
//                 ma.split("_")[1]
//               }</option>`;
//           }
//           $(this2).find(".makeselect").html(strmake);
//           $(this2).find(".makeselect").removeAttr("disabled");
//           $(this2).find(".finder-box").removeClass("active");
//           $(this2)
//             .find(".makeselect")
//             .parents(".finder-box")
//             .addClass("active");
//           var models = [];

//           var datasearch = {};

//           var found = false;

//           $.each(jsonarr, function (index, value) {
//             if ($.inArray(value.model, models) === -1) {
//               if (value.make.toUpperCase() == maketag) {
//                 models.push(value.model);
//                 if (found == false) {
//                   found = true;
//                 }
//               }
//             }
//           });

//           models.sort();

//           var modelhtml =
//             '<option value="Select Model" disabled selected>Select Model</option>';
//           for (var i = 0; i < models.length; i++) {
//             var mo = models[i];
//             modelhtml =
//               modelhtml +
//               `<option value='${mo.replace(".", "")}'>${
//                 mo.split("_")[1]
//               }</option>`;
//           }
//           $(this2).find(".modelselect").html(modelhtml);
//           $(this2).find(".modelselect").removeAttr("disabled");
//           $(this2).find(".finder-box").removeClass("active");
//           $(this2)
//             .find(".modelselect")
//             .parents(".finder-box")
//             .addClass("active");
//           $(this2)
//             .find(".yearselect")
//             .html(
//               '<option value="Select Year" disabled selected>Select Year</option>'
//             );
//           $(this2).find(".yearselect").attr("disabled", true);

//           $(this2)
//             .find(".makeselect")
//             .change(function () {
//               $(this2).find(".makeselect").val($(this).val());
//               var models = [];
//               var selmake = $(this).val();
//               $.each(jsonarr, function (index, value) {
//                 if ($.inArray(value.model, models) === -1) {
//                   if (value.make == selmake) {
//                     models.push(value.model);
//                   }
//                 }
//               });
//               models.sort();
//               var modelhtml =
//                 '<option value="Select Model" disabled selected>Select Model</option>';
//               for (var i = 0; i < models.length; i++) {
//                 var mo = models[i];
//                 var valmo = mo.replace(".", "");
//                 valmo = valmo.replace("'", "");
//                 valmo = valmo.replace('"', "");
//                 modelhtml =
//                   modelhtml +
//                   `<option value='${valmo}'>${mo.split("_")[1]}</option>`;
//               }
//               $(this2).find(".modelselect").html(modelhtml);
//               $(this2).find(".modelselect").removeAttr("disabled");
//               $(this2).find(".finder-box").removeClass("active");
//               $(this2)
//                 .find(".modelselect")
//                 .parents(".finder-box")
//                 .addClass("active");
//               var yearhtml =
//                 '<option value="Select Year" disabled selected>Select Year</option>';
//               $(this2).find(".yearselect").html(yearhtml);
//               $(this2).find(".yearselect").attr("disabled", true);
//             });

//           $(this2)
//             .find(".modelselect")
//             .change(function () {
//               $(this2).find(".modelselect").val($(this).val());
//               $(this2).find(".amfinder-reset").show();
//               var years = [];
//               var selmodel = $(this).val().toUpperCase();
//               var selmake = $(this)
//                 .parents(".select-wrapper")
//                 .find(".makeselect")
//                 .val();
//               $.each(jsonarr, function (index, value) {
//                 if ($.inArray(value.year, years) === -1) {
//                   if (
//                     value.model.toUpperCase() == selmodel &&
//                     value.make.toUpperCase() == selmake.toUpperCase()
//                   ) {
//                     years.push(value.year);
//                   }
//                 }
//               });
//               years.sort();
//               var yearhtml =
//                 '<option value="Select Year" disabled selected>Select Year</option>';
//               for (var i = 0; i < years.length; i++) {
//                 var ye = years[i];
//                 var valyear = ye.replace(".", "");
//                 valyear = valyear.replace("'", "");
//                 valyear = valyear.replace('"', "");
//                 yearhtml =
//                   yearhtml +
//                   `<option value='${valyear}'>${ye.split("_")[1]}</option>`;
//               }
//               $(this2).find(".yearselect").html(yearhtml);
//               $(this2).find(".yearselect").removeAttr("disabled");
//               $(this2).find(".finder-box").removeClass("active");
//               $(this2)
//                 .find(".yearselect")
//                 .parents(".finder-box")
//                 .addClass("active");
//             });

//           $(this2)
//             .find(".yearselect")
//             .change(function () {
//               $(this2).find(".yearselect").val($(this).val());
//               var yearc = $(this)
//                 .parents(".select-wrapper")
//                 .find(".yearselect")
//                 .val()
//                 .replace(".", "")
//                 .replace("&", "%26")
//                 .toLowerCase();
//               var makec = $(this)
//                 .parents(".select-wrapper")
//                 .find(".makeselect")
//                 .val()
//                 .replace(".", "")
//                 .replace("&", "%26")
//                 .toLowerCase();
//               makec = makec.replace("/", "-");
//               var modelc = $(this)
//                 .parents(".select-wrapper")
//                 .find(".modelselect")
//                 .val()
//                 .replace(".", "")
//                 .replace("&", "%26")
//                 .toLowerCase();
//               var smodelc = modelc.split("/").join("-");
//               var redurl =
//                 handle +
//                 "?year=" +
//                 yearc.split("_")[1] +
//                 "&make=" +
//                 makec.split("_")[1] +
//                 "&model=" +
//                 modelc.split("_")[1];

//               localStorage.clear();
//               window.location.href = redurl;
//             });
//         }

//         if (hasyear == true && hasmodel == true && hasmake == true) {
//           var redurl =
//             handle +
//             "?year=" +
//             urlParams.get("year") +
//             "&make=" +
//             urlParams.get("make") +
//             "&model=" +
//             urlParams.get("model");

//           localStorage.clear();
//           window.location.href = redurl;
//         }

//         $(".amfinder-reset").click(function () {
//           window.location.href = handle;
//         });
//       }
//     });
//   }
// }

// customElements.define("filter-cover", FilterCover);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector(".icon");
  }

  connectedCallback() {
    document.addEventListener(
      "storefront:signincompleted",
      this.handleStorefrontSignInCompleted.bind(this)
    );
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define("account-icon", AccountIcon);

class HomeBanner extends HTMLElement {
  constructor() {
    super();

    var swiper = new Swiper(".custom-banner-slider", {
      slidesPerView: 1,
      spaceBetween: 0,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      effect: "fade",
      loop: true,
    });
    var this2 = this;

    var csvurl = "";
    var jsonarr = [];
    $(this)
      .find(".catselect")
      .change(function () {
        jsonarr = [];
        csvurl = $(this).find("option:selected").attr("data-csv");

        var href = new URL(csvurl);
        var random = Math.floor(Math.random() * 100000000);
        href.searchParams.set("v", random);
        csvurl = href.toString();

        $(this2).find(".yearselect").attr("disabled", "true");
        $.ajax({
          type: "GET",
          url: csvurl,
          dataType: "text",
          success: function (data) {
            var csvData = data;
            let word_array = $.csv.toArrays(csvData);

            for (let index = 1; index < word_array.length; index++) {
              var ob = {};
              ob["category"] = word_array[index][0];
              ob["year"] = word_array[index][1];
              ob["make"] = word_array[index][2];
              ob["model"] = word_array[index][3];
              ob["brand"] = word_array[index][4];
              jsonarr.push(ob);
            }
            setDataInPage(jsonarr);
          },
        });
      });

    function setDataInPage(jsonarr) {
      var strpart = $(this2).find(".car-cover-main-container").data("strpart");
      var curl = $(this2).find(".car-cover-main-container").data("url");
      var colltitle = $(this2).find(".car-cover-main-container").data("title");
      var collprotitle = $(this2)
        .find(".car-cover-main-container")
        .data("protitle");

      var years = [];
      $.each(jsonarr, function (index, value) {
        if ($.inArray(value.year, years) === -1) {
          years.push(value.year);
        }
      });
      loadData(years);

      function loadData(years) {
        years.sort();
        years.reverse();
        var stryear =
          '<option value="Select Year" disabled selected>Select Year</option>';
        for (var i = 0; i < years.length; i++) {
          var yy = years[i];
          stryear =
            stryear + `<option value='${yy}'>${yy.split("_")[1]}</option>`;
        }
        $(this2).find(".yearselect").html(stryear);
        $(this2).find(".yearselect").removeAttr("disabled");
        $(this2).find(".input-container").removeClass("active");
        $(this2).find(".yearselect").parent().addClass("active");
        $(this2)
          .find(".modelselect")
          .html(
            '<option value="Please Select" disabled selected>Select Model</option>'
          );
        $(this2)
          .find(".makeselect")
          .html(
            '<option value="Please Select" disabled selected>Select Make</option>'
          );

        $(this2)
          .find(".yearselect")
          .change(function () {
            $(this2).find(".yearselect").val($(this).val());
            $(this2).find(".amfinder-reset").show();

            $(this2)
              .find(".modelselect")
              .html(
                '<option value="Please Select" disabled selected>Loading..</option>'
              );
            $(this2)
              .find(".makeselect")
              .html(
                '<option value="Please Select" disabled selected>Loading..</option>'
              );
            $(this2).find(".modelselect").attr("disabled", "true");
            $(this2).find(".makeselect").attr("disabled", "true");

            var makes = [];
            var selyear = $(this).val();
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.make, makes) === -1) {
                if (value.year == selyear) {
                  makes.push(value.make);
                }
              }
            });
            makes.sort();
            var strmake =
              '<option value="Select Make" disabled selected>Select Make</option>';
            for (var i = 0; i < makes.length; i++) {
              var ma = makes[i];
              strmake =
                strmake +
                `<option value='${ma.replace(".", "")}'>${
                  ma.split("_")[1]
                }</option>`;
            }
            $(this2).find(".makeselect").html(strmake);
            $(this2).find(".makeselect").removeAttr("disabled");
            $(this2).find(".input-container").removeClass("active");
            $(this2).find(".makeselect").parent().addClass("active");
            $(this2)
              .find(".modelselect")
              .html(
                '<option value="Select Model" disabled selected>Select Model</option>'
              );
            $(this2).find(".modelselect").attr("disabled", true);
          });
        $(this2)
          .find(".makeselect")
          .change(function () {
            $(this2).find(".makeselect").val($(this).val());
            $(this2).find(".amfinder-reset").show();

            var models = [];
            var selyear = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val();
            var selmake = $(this).val();
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.model, models) === -1) {
                if (value.year == selyear && value.make == selmake) {
                  models.push(value.model);
                }
              }
            });
            models.sort();
            var modelhtml =
              '<option value="Select Model" disabled selected>Select Model</option>';
            for (var i = 0; i < models.length; i++) {
              var mo = models[i];
              modelhtml =
                modelhtml +
                `<option value='${mo.replace(".", "")}'>${
                  mo.split("_")[1]
                }</option>`;
            }
            $(this2).find(".modelselect").html(modelhtml);
            $(this2).find(".modelselect").removeAttr("disabled");
            $(this2).find(".input-container").removeClass("active");
            $(this2).find(".modelselect").parent().addClass("active");
          });

        $(this2)
          .find(".modelselect")
          .change(function () {
            $(this2).find(".modelselect").val($(this).val());
            $(this2).find(".search--button").removeAttr("disabled");
            $(this2).find(".input-container").removeClass("active");
          });

        //$(".search--button").click(function ()
        $(this2)
          .find(".modelselect")
          .change(function () {
            $(this2).find(".modelselect").val($(this).val());
            var yearc = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val()
              .replace(".", "")
              .replace("&", "%26") ;
            var makec = $(this)
              .parents(".select-wrapper")
              .find(".makeselect")
              .val()
              .replace(".", "")
              .replace("&", "%26") ;
            makec = makec.replace("/", "-");
            var modelc = $(this)
              .parents(".select-wrapper")
              .find(".modelselect")
              .val()
              .replace(".", "")
              .replace("&", "%26") ;
            var smodelc = modelc.split("/").join("-");
            var strpartn =
              yearc +
              "+" +
              makec +
              "+" +
              smodelc;
            var handle = $(this)
              .parents(".select-wrapper")
              .find(".catselect")
              .val();
            var redurl =
              "/collections/" +
              handle +
              "?year=" +
              yearc.split("_")[1] +
              "&make=" +
              makec.split("_")[1] +
              "&model=" +
              modelc.split("_")[1];
            localStorage.clear();
            window.location.href = redurl;
          });
      }
    }
  }
}

customElements.define("homepage-banner", HomeBanner);

class MiniPopupCollection extends HTMLElement {
  constructor() {
    super();

    var swiper = new Swiper(".custom-banner-slider", {
      slidesPerView: 1,
      spaceBetween: 0,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      effect: "fade",
      loop: true,
    });

    var csvurl = "";
    var jsonarr = [];
    var this2 = this;
    $(this)
      .find(".catselect")
      .change(function () {
        jsonarr = [];
        csvurl = $(this).find("option:selected").attr("data-csv");
        console.log(csvurl);
        //   var href = new URL(csvurl);
        // var random = Math.floor(Math.random() * 100000000);
        // href.searchParams.set("v", random);
        // csvurl = href.toString();

        $(this).find(".yearselect").attr("disabled", "true");
        $.ajax({
          type: "GET",
          url: csvurl,
          dataType: "text",
          success: function (data) {
            var csvData = data;
            let word_array = $.csv.toArrays(csvData);

            for (let index = 1; index < word_array.length; index++) {
              var ob = {};
              ob["category"] = word_array[index][0];
              ob["year"] = word_array[index][1];
              ob["make"] = word_array[index][2];
              ob["model"] = word_array[index][3];
              ob["brand"] = word_array[index][4];
              jsonarr.push(ob);
            }
            setDataInPage(jsonarr);
          },
        });
      });

    function setDataInPage(jsonarr) {
      var strpart = $(this2).find(".car-cover-main-container").data("strpart");
      var curl = $(this2).find(".car-cover-main-container").data("url");
      var colltitle = $(this2).find(".car-cover-main-container").data("title");
      var collprotitle = $(this2)
        .find(".car-cover-main-container")
        .data("protitle");

      var years = [];
      $.each(jsonarr, function (index, value) {
        if ($.inArray(value.year, years) === -1) {
          years.push(value.year);
        }
      });
      loadData(years);

      function loadData(years) {
        years.sort();
        years.reverse();
        var stryear =
          '<option value="Select Year" disabled selected>Select Year</option>';
        for (var i = 0; i < years.length; i++) {
          var yy = years[i];
          stryear =
            stryear + `<option value='${yy}'>${yy.split("_")[1]}</option>`;
        }
        $(this2).find(".yearselect").html(stryear);
        $(this2).find(".yearselect").removeAttr("disabled");
        $(this2).find(".input-container").removeClass("active");
        $(this2).find(".yearselect").parent().addClass("active");
        $(this2)
          .find(".modelselect")
          .html(
            '<option value="Please Select" disabled selected>Select Model</option>'
          );
        $(this2)
          .find(".makeselect")
          .html(
            '<option value="Please Select" disabled selected>Select Make</option>'
          );

        $(this2)
          .find(".yearselect")
          .change(function () {
            $(this2).find(".yearselect").val($(this).val());

            $(this2)
              .find(".modelselect")
              .html(
                '<option value="Please Select" disabled selected>Loading..</option>'
              );
            $(this2)
              .find(".makeselect")
              .html(
                '<option value="Please Select" disabled selected>Loading..</option>'
              );
            $(this2).find(".modelselect").attr("disabled", "true");
            $(this2).find(".makeselect").attr("disabled", "true");

            var makes = [];
            var selyear = $(this).val();
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.make, makes) === -1) {
                if (value.year == selyear) {
                  makes.push(value.make);
                }
              }
            });
            makes.sort();
            var strmake =
              '<option value="Select Make" disabled selected>Select Make</option>';
            for (var i = 0; i < makes.length; i++) {
              var ma = makes[i];
              strmake =
                strmake +
                `<option value='${ma.replace(".", "")}'>${
                  ma.split("_")[1]
                }</option>`;
            }
            $(this2).find(".makeselect").html(strmake);
            $(this2).find(".makeselect").removeAttr("disabled");
            $(this2).find(".input-container").removeClass("active");
            $(this2).find(".makeselect").parent().addClass("active");
            $(this2)
              .find(".modelselect")
              .html(
                '<option value="Select Model" disabled selected>Select Model</option>'
              );
            $(this2).find(".modelselect").attr("disabled", true);
          });
        $(this2)
          .find(".makeselect")
          .change(function () {
            $(this2).find(".makeselect").val($(this).val());

            var models = [];
            var selyear = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val();
            var selmake = $(this).val();
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.model, models) === -1) {
                if (value.year == selyear && value.make == selmake) {
                  models.push(value.model);
                }
              }
            });
            models.sort();
            var modelhtml =
              '<option value="Select Model" disabled selected>Select Model</option>';
            for (var i = 0; i < models.length; i++) {
              var mo = models[i];
              modelhtml =
                modelhtml +
                `<option value='${mo.replace(".", "")}'>${
                  mo.split("_")[1]
                }</option>`;
            }
            $(this2).find(".modelselect").html(modelhtml);
            $(this2).find(".modelselect").removeAttr("disabled");
            $(this2).find(".input-container").removeClass("active");
            $(this2).find(".modelselect").parent().addClass("active");
          });

        $(this2)
          .find(".modelselect")
          .change(function () {
            $(this2).find(".modelselect").val($(this).val());
            $(this2).find(".search--button").removeAttr("disabled");
            $(this2).find(".input-container").removeClass("active");
          });

        //$(".search--button").click(function ()
        $(this2)
          .find(".modelselect")
          .change(function () {
            $(this2).find(".modelselect").val($(this).val());
            var yearc = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val()
              .replace(".", "")
              .replace("&", "%26");
            var makec = $(this)
              .parents(".select-wrapper")
              .find(".makeselect")
              .val()
              .replace(".", "")
              .replace("&", "%26");
            makec = makec.replace("/", "-");
            var modelc = $(this)
              .parents(".select-wrapper")
              .find(".modelselect")
              .val()
              .replace(".", "")
              .replace("&", "%26");
            var smodelc = modelc.split("/").join("-");
            var strpartn =
              yearc +
              "+" +
              makec +
              "+" +
              smodelc;
            var handle = $(this)
              .parents(".select-wrapper")
              .find(".catselect")
              .val();
            var redurl =
              "/collections/" +
              handle +
              "?year=" +
              yearc.split("_")[1] +
              "&make=" +
              makec.split("_")[1] +
              "&model=" +
              modelc.split("_")[1];
            localStorage.clear();
            window.location.href = redurl;
          });
      }
    }
  }
}

customElements.define("mini-popup-collection", MiniPopupCollection);

class MiniPopup extends HTMLElement {
  constructor() {
    super();

    var swiper = new Swiper(".custom-banner-slider", {
      slidesPerView: 1,
      spaceBetween: 0,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      effect: "fade",
      loop: true,
    });

    var csvurl = "";
    var jsonarr = [];
    var this2 = this;
    $(this)
      .find(".catselect")
      .change(function () {
        jsonarr = [];
        csvurl = $(this).find("option:selected").attr("data-csv");
        console.log(csvurl);
        //   var href = new URL(csvurl);
        // var random = Math.floor(Math.random() * 100000000);
        // href.searchParams.set("v", random);
        // csvurl = href.toString();

        $(this).find(".yearselect").attr("disabled", "true");
        $.ajax({
          type: "GET",
          url: csvurl,
          dataType: "text",
          success: function (data) {
            var csvData = data;
            let word_array = $.csv.toArrays(csvData);

            for (let index = 1; index < word_array.length; index++) {
              var ob = {};
              ob["category"] = word_array[index][0];
              ob["year"] = word_array[index][1];
              ob["make"] = word_array[index][2];
              ob["model"] = word_array[index][3];
              ob["brand"] = word_array[index][4];
              jsonarr.push(ob);
            }
            setDataInPage(jsonarr);
          },
        });
      });

    function setDataInPage(jsonarr) {
      var strpart = $(this2).find(".car-cover-main-container").data("strpart");
      var curl = $(this2).find(".car-cover-main-container").data("url");
      var colltitle = $(this2).find(".car-cover-main-container").data("title");
      var collprotitle = $(this2)
        .find(".car-cover-main-container")
        .data("protitle");

      var years = [];
      $.each(jsonarr, function (index, value) {
        if ($.inArray(value.year, years) === -1) {
          years.push(value.year);
        }
      });
      loadData(years);

      function loadData(years) {
        years.sort();
        years.reverse();
        var stryear =
          '<option value="Select Year" disabled selected>Select Year</option>';
        for (var i = 0; i < years.length; i++) {
          var yy = years[i];
          stryear =
            stryear + `<option value='${yy}'>${yy.split("_")[1]}</option>`;
        }
        $(this2).find(".yearselect").html(stryear);
        $(this2).find(".yearselect").removeAttr("disabled");
        $(this2).find(".input-container").removeClass("active");
        $(this2).find(".yearselect").parent().addClass("active");
        $(this2)
          .find(".modelselect")
          .html(
            '<option value="Please Select" disabled selected>Select Model</option>'
          );
        $(this2)
          .find(".makeselect")
          .html(
            '<option value="Please Select" disabled selected>Select Make</option>'
          );

        $(this2)
          .find(".yearselect")
          .change(function () {
            $(this2).find(".yearselect").val($(this).val());

            $(this2)
              .find(".modelselect")
              .html(
                '<option value="Please Select" disabled selected>Loading..</option>'
              );
            $(this2)
              .find(".makeselect")
              .html(
                '<option value="Please Select" disabled selected>Loading..</option>'
              );
            $(this2).find(".modelselect").attr("disabled", "true");
            $(this2).find(".makeselect").attr("disabled", "true");

            var makes = [];
            var selyear = $(this).val();
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.make, makes) === -1) {
                if (value.year == selyear) {
                  makes.push(value.make);
                }
              }
            });
            makes.sort();
            var strmake =
              '<option value="Select Make" disabled selected>Select Make</option>';
            for (var i = 0; i < makes.length; i++) {
              var ma = makes[i];
              strmake =
                strmake +
                `<option value='${ma.replace(".", "")}'>${
                  ma.split("_")[1]
                }</option>`;
            }
            $(this2).find(".makeselect").html(strmake);
            $(this2).find(".makeselect").removeAttr("disabled");
            $(this2).find(".input-container").removeClass("active");
            $(this2).find(".makeselect").parent().addClass("active");
            $(this2)
              .find(".modelselect")
              .html(
                '<option value="Select Model" disabled selected>Select Model</option>'
              );
            $(this2).find(".modelselect").attr("disabled", true);
          });
        $(this2)
          .find(".makeselect")
          .change(function () {
            $(this2).find(".makeselect").val($(this).val());

            var models = [];
            var selyear = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val();
            var selmake = $(this).val();
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.model, models) === -1) {
                if (value.year == selyear && value.make == selmake) {
                  models.push(value.model);
                }
              }
            });
            models.sort();
            var modelhtml =
              '<option value="Select Model" disabled selected>Select Model</option>';
            for (var i = 0; i < models.length; i++) {
              var mo = models[i];
              modelhtml =
                modelhtml +
                `<option value='${mo.replace(".", "")}'>${
                  mo.split("_")[1]
                }</option>`;
            }
            $(this2).find(".modelselect").html(modelhtml);
            $(this2).find(".modelselect").removeAttr("disabled");
            $(this2).find(".input-container").removeClass("active");
            $(this2).find(".modelselect").parent().addClass("active");
          });

        $(this2)
          .find(".modelselect")
          .change(function () {
            $(this2).find(".modelselect").val($(this).val());
            $(this2).find(".search--button").removeAttr("disabled");
            $(this2).find(".input-container").removeClass("active");
          });

        //$(".search--button").click(function ()
        $(this2)
          .find(".modelselect")
          .change(function () {
            $(this2).find(".modelselect").val($(this).val());
            var yearc = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val()
              .replace(".", "")
              .replace("&", "%26");
            var makec = $(this)
              .parents(".select-wrapper")
              .find(".makeselect")
              .val()
              .replace(".", "")
              .replace("&", "%26");
            makec = makec.replace("/", "-");
            var modelc = $(this)
              .parents(".select-wrapper")
              .find(".modelselect")
              .val()
              .replace(".", "")
              .replace("&", "%26");
            var smodelc = modelc.split("/").join("-");
            var strpartn =
              yearc +
              "+" +
              makec +
              "+" +
              smodelc;
            var handle = $(this)
              .parents(".select-wrapper")
              .find(".catselect")
              .val();
            var redurl =
              "/collections/" +
              handle +
              "?year=" +
              yearc.split("_")[1] +
              "&make=" +
              makec.split("_")[1] +
              "&model=" +
              modelc.split("_")[1];
            localStorage.clear();
            window.location.href = redurl;
          });
      }
    }
  }
}

customElements.define("mini-popup", MiniPopup);

class PopupProduct extends HTMLElement {
  constructor() {
    super();
    $(document).ready(function () {
      $(".style-category-wrapper").each(function () {
        $(this)
          .find(".collection-container")
          .unbind()
          .click(function () {
            $(this)
              .siblings("popup-product")
              .find(".category-popup")
              .css("display", "flex");
            $(this)
              .siblings("popup-product")
              .find(".category-popup")
              .addClass("active");
          });

        $(this)
          .find(".cat-link-item")
          .change(function () {
            window.location.href = $(this).val();
            fireAdRollSegment("9cb5aecd");
            $(".after-reset").show();
          });
      });
    });
  }
}

customElements.define("popup-product", PopupProduct);

class ShopByStyleLanding extends HTMLElement {
  constructor() {
    super();
    $(window).on("load resize", function () {
      $(".custom-logo-collection-read-btn")
        .unbind()
        .click(function () {
          if ($(window).width() < 897) {
            $(".mobile-style-category-wrapper").toggle();
          } else {
            $(".extra-content-target").toggle();
          }
          $(".custom-logo-readmore").toggle();
          $(".custom--logo-readless").toggle();
          $(".custom-logo-collection-read-btn").toggleClass("active");
        });

        $(".custom-logo-collection-read-btn.desktop-view").click(function () {
          $(this).parent().toggleClass("sbs-desktop-active");
        });
        
        $(".custom-logo-collection-read-btn.mobile-view").click(function () {
          $(this).parent().toggleClass("sbs-mobile-active");
        });
    });
  }
}



customElements.define("shop-by-style-collection", ShopByStyleLanding);

class CustomContent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(".custom-collection-read-btn")
        .unbind()
        .click(function () {
          $(".mobile-content").toggle();
          $(".desktop-content").toggle();
          $(".custom-readmore").toggle();
          $(".custom-readless").toggle();
          $(".custom-collection-read-btn").toggleClass("active");
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-content", CustomContent);

class CustomSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      var swiper = new Swiper(".thumb-slider", {
        spaceBetween: 10,
        slidesPerView: 3,
        navigation: {
          nextEl: ".swiper-button-next-thumb",
          prevEl: ".swiper-button-prev-thumb",
        },
        breakpoints: {
          768: {
            slidesPerView: 4,
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 10,
          },
        },
      });
      var swiper2 = new Swiper(".main-slider", {
        slidesPerView: 1,
        pagination: {
          el: ".swiper-pagination",
        },
        breakpoints: {
          768: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
        },
        spaceBetween: 10,
      });
      $(".thumb-slider .swiper-slide:visible").eq(0).addClass("active");
      $(".thumb-img").click(function () {
        var count = 0;
        var cindex = 0;
        var mediaindex = $(this).parent().data("index");
        $(".thumb-slider .swiper-slide").removeClass("active");
        $(this).parent().addClass("active");
        $(".main-slider .swiper-slide:visible").each(function (index) {
          if ($(this).data("index") == mediaindex) {
            cindex = count;
          }
          count++;
        });
        swiper2.slideTo(cindex);
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-slider", CustomSlider);

class CustomMainProductWrapper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(".products-notes-title").click(function () {
        $(this).parent().toggleClass("active");
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-main-product-wrapper", CustomMainProductWrapper);

class CustomTestimonial extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(this).css({ opacity: "1" });
      var swiper = new Swiper(".custom-testimoials-slider", {
        observer: true,
        observeParents: true,
        slidesPerView: 2,
        spaceBetween: 10,
        navigation: {
          nextEl: ".testimonials-button-next",
          prevEl: ".testimonials-button-prev",
        },
        pagination: {
          el: ".testimonial-pagination",
          clickable: true,
        },
        breakpoints: {
          741: {
            slidesPerView: 3,
            spaceBetween: 7,
          },
        },
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-testimonial", CustomTestimonial);

class CustomFeaturedProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      var this2 = this;
      var swiper = new Swiper(".custom-featured-category-slider", {
        spaceBetween: 0,

        slidesPerView: "auto",
        freeMode: true,
        css: true,
        watchSlidesProgress: true,
      });

      var swiper2 = new Swiper(".custom-featured-products-slider", {
        spaceBetween: 0,
        slidesPerView: 1,
        navigation: {
          nextEl: ".featured-button-next",
          prevEl: ".featured-button-prev",
        },
        pagination: {
          el: ".featured-pagination",
          clickable: true,
        },
        thumbs: {
          swiper: swiper,
        },
      });

      $(".custom-featured-products-wrapper .customer-satisfied-counts").each(
        function () {
          var startNumber = parseInt($(this).data("start"));
          var endNumber = parseInt($(this).data("end"));

          $(this)
            .prop("Counter", startNumber)
            .animate(
              {
                Counter: endNumber,
              },
              {
                duration: 4000,
                easing: "swing",
                step: function (now) {
                  // Format the number with commas
                  var formattedNumber = Math.ceil(now).toLocaleString();
                  $(this).text(formattedNumber + "+");
                },
              }
            );
        }
      );

      $(".custom-product-color-item").click(function () {
        $(this)
          .parents(".custom-product-color-container")
          .find(".custom-product-color-item")
          .removeClass("active");
        $(this).addClass("active");
        $(this)
          .parents(".custom-featured-product-media")
          .find("a").find('img')
          .attr("src", $(this).data("image"));
      });

      $(".custom-featured-button").click(function () {
        $(this2).find(".main-mini-popup.featured-popup").show();
        $(this2).find(".main-mini-popup.featured-popup").addClass("active");
      });

      $(".custom-main-product-media").click(function () {
        $(this2).find(".main-mini-popup.featured-popup").show();
        $(this2).find(".main-mini-popup.featured-popup").addClass("active");
      });

      $(".show_more_less_swtach")
        .unbind()
        .click(function () {
          // $(this).siblings().toggleClass("shown");
          $(this)
            .parent(".custom-product-color-container")
            .toggleClass("active-tab");
          $(this)
            .parents(".custom-product-item-bottom")
            .toggleClass("active-tab");
        });

      $(".show_more_less")
        .unbind()
        .click(function () {
          $(this)
            .parents(".custom-featured-product-description")
            .toggleClass("active");
          $(this).toggleClass("active");
        });

      $(".custom-featured-description")
        .unbind()
        .click(function () {
          $(this)
            .parents(".custom-featured-product-description")
            .toggleClass("active");
          $(".show_more_less").toggleClass("active");
        });
      $(".custom-featured-products-slider")
        .unbind()
        .click(function () {
          $(this).find(".featured-button-next").addClass("active");
        });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-featured-products", CustomFeaturedProducts);

class customsectionaccordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(".custom-accordion-container")
        .unbind()
        .click(function (e) {
          e.preventDefault();

          let $this = $(this);

          if ($this.next().hasClass("show")) {
            $this.next().removeClass("show");
            $this.next().slideUp(350);

            $this
              .find(".faq-icon-container")
              .find(".faqplus")
              .css({ display: "flex" });
            $this
              .find(".faq-icon-container")
              .find(".faqminus")
              .css({ display: "none" });
          } else {
            $this
              .parent()
              .parent()
              .find(".accordian-content")
              .removeClass("show");
            $this.parent().parent().find(".accordian-content").slideUp(350);

            $this
              .parent()
              .parent()
              .find(".faq-icon-container")
              .find(".faqplus")
              .css({ display: "flex" });
            $this
              .parent()
              .parent()
              .find(".faq-icon-container")
              .find(".faqminus")
              .css({ display: "none" });

            $this.next().toggleClass("show");
            $this.next().slideToggle(350);

            $this
              .find(".faq-icon-container")
              .find(".faqplus")
              .css({ display: "none" });
            $this
              .find(".faq-icon-container")
              .find(".faqminus")
              .css({ display: "flex" });
          }

          $(".custom-collapsible-inner-content").css({ display: "none" });
        });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-section-accordion", customsectionaccordion);

class ProductDescription extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      // function resizeLogic() {
      //   if ($(window).width() < 897) {
          // $(".mobile-description-accordion .mobile-description-title").click(
          //   function () {
          //     if (
          //       $(this)
          //         .parent(".mobile-description-accordion")
          //         .hasClass("active")
          //     ) {
          //       $(".mobile-description-accordion").removeClass("active");
          //       $(this)
          //         .parent(".mobile-description-accordion")
          //         .removeClass("active");
          //     } else {
          //       $(".mobile-description-accordion").removeClass("active");
          //       $(this)
          //         .parent(".mobile-description-accordion")
          //         .addClass("active");
          //     }
          //     // function () {
          //     //   $(this).parent().toggleClass("active");
          //     // }
          //   }
          // );
        // } else {
          // $(".main-product-title").click(function () {
          //   $(".main-product-title").removeClass("active");
          //   $(this).addClass("active");
          //   var match = $(this).attr("title");
          //   $(".main-product-description > div").removeClass("active");
          //   $(
          //     '.main-product-description > div[content="' + match + '"]'
          //   ).addClass("active");
          // });
      //   }
      // }
      // resizeLogic(); // on load
      // $(window).resize(resizeLogic); // on window resize
// Mobile
       $(".mobile-description-accordion .mobile-description-title").click(
            function () {
              if (
                $(this)
                  .parent(".mobile-description-accordion")
                  .hasClass("active")
              ) {
                // $(".mobile-description-accordion").removeClass("active");
                $(this)
                  .parent(".mobile-description-accordion")
                  .removeClass("active");
              } else {
                // $(".mobile-description-accordion").removeClass("active");
                $(this)
                  .parent(".mobile-description-accordion")
                  .addClass("active");
              }
              // function () {
              //   $(this).parent().toggleClass("active");
              // }
            }
          );
// desktop screen
       $(".main-product-title").click(function () {
            $(".main-product-title").removeClass("active");
            $(this).addClass("active");
            var match = $(this).attr("title");
            $(".main-product-description > div").removeClass("active");
            $(
              '.main-product-description > div[content="' + match + '"]'
            ).addClass("active");
          });

      
      $(".faq-title")
        .unbind()
        .click(function () {
          if ($(this).parent(".faq_item").hasClass("active")) {
            $(".faq_item").removeClass("active");
            $(this).parent(".faq_item").removeClass("active");
          } else {
            $(".faq_item").removeClass("active");
            $(this).parent(".faq_item").addClass("active");
          }
        });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-description", ProductDescription);

class imageslider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(
        ".image-slider--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 2,
          spaceBetween: 7,
          // loop: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          pagination: {
            clickable: true,
            el: ".swiper-pagination",
          },
          breakpoints: {
            767: {
              slidesPerView: 3,
              spaceBetween: 8,
            },
            990: {
              slidesPerView: 4,
              spaceBetween: 10,
            },
            1050: {
              slidesPerView: 5,
              spaceBetween: 18,
            },
          },
        }
      );
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("image-slider", imageslider);

class FaqSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(".faq-questions-" + this.getAttribute("data-sectionid")).click(
        function (e) {
          e.preventDefault();

          let $this = $(this);

          if ($this.next().hasClass("show")) {
            $this.next().removeClass("show");
            $this.next().slideUp(350);
            $this.parent().removeClass("active");

            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-down")
              .css({ display: "flex" });
            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-up")
              .css({ display: "none" });
          } else {
            $(".custom-card-main").find(".faq-answers").removeClass("show");
            $(".custom-card-main").find(".faq-answers").slideUp(350);
            $(".custom-card-main").removeClass("active");

            $(".custom-card-main")
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-down")
              .css({ display: "flex" });
            $(".custom-card-main")
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-up")
              .css({ display: "none" });

            $this.next().toggleClass("show");
            $this.next().slideToggle(350);
            $this.parent().toggleClass("active");

            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-down")
              .css({ display: "none" });
            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-up")
              .css({ display: "flex" });
          }
        }
      );
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("faq-section", FaqSection);

class mainproductmockup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      var url_string = window.location.href;
      var url = new URL(url_string);
      var make = url.searchParams.get("make");
      var model = url.searchParams.get("model");
      var year = url.searchParams.get("year");
      var csvurl = $(this).data("csvurl");
      var href = new URL(csvurl);
      var random = Math.floor(Math.random() * 100000000);
      href.searchParams.set("v", random);
      csvurl = href.toString();
      var maintitle = $(this).data("maintitle");
      var handle = $(this).data("landingcoll");
      var this2 = this;
      var jsonarr = [];

      $(this2).find(".yearselect").attr("disabled", "true");
      $.ajax({
        type: "GET",
        url: csvurl,
        dataType: "text",
        success: function (data) {
          var csvData = data;
          let word_array = $.csv.toArrays(csvData);

          for (let index = 1; index < word_array.length; index++) {
            var ob = {};
            ob["category"] = word_array[index][0];
            ob["year"] = word_array[index][1];
            ob["make"] = word_array[index][2];
            ob["model"] = word_array[index][3];
            ob["title"] = word_array[index][4];
            ob["images"] = word_array[index][5];
            ob["instock"] = word_array[index][6];
            ob["price"] = word_array[index][7];
            ob["compprice"] = word_array[index][8];
            ob["tags"] = word_array[index][9];
            jsonarr.push(ob);
          }
          setSelectTags(jsonarr);
        },
      });

      function setSelectTags(jsonarr) {
        var hasyear = false;
        var hasmake = false;
        var hasmodel = false;
        var namestr = "";

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        $.each(jsonarr, function (index, value) {
          if (urlParams.has("year")) {
            var yeartag = "YEAR_" + urlParams.get("year").toUpperCase();
            if (value.year.toUpperCase() == yeartag) {
              hasyear = true;
            }
          }
        });

        $.each(jsonarr, function (index, value) {
          if (urlParams.has("make")) {
            var maketag = "MAKE_" + urlParams.get("make").toUpperCase();
            if (value.make.toUpperCase() == maketag) {
              hasmake = true;
            }
          }
        });

        $.each(jsonarr, function (index, value) {
          if (urlParams.has("model")) {
            var modeltag = "MODEL_" + urlParams.get("model").toUpperCase();
            if (value.model.toUpperCase() == modeltag) {
              hasmodel = true;
            }
          }
        });

        if (hasmodel == true && hasmake == true) {
          namestr = urlParams.get("make") + " " + urlParams.get("model");
          var maketag = "MAKE_" + urlParams.get("make").toUpperCase();
          var modeltag = "MODEL_" + urlParams.get("model").toUpperCase();

          var makes = [];
          var selyear = $(this).val();
          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.make, makes) === -1) {
              makes.push(value.make);
            }
          });
          makes.sort();
          var strmake =
            '<option value="Select Make" disabled>Select Make</option>';
          for (var i = 0; i < makes.length; i++) {
            var ma = makes[i];
            var selected = "";
            if (ma.toUpperCase() == maketag) {
              selected = "selected";
            }
            strmake =
              strmake +
              `<option value='${ma.replace(".", "")}' ${selected}>${
                ma.split("_")[1]
              }</option>`;
          }
          $(this2).find(".makeselect").html(strmake);
          $(this2).find(".makeselect").removeAttr("disabled");

          var models = [];
          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.model, models) === -1) {
              if (value.make.toUpperCase() == maketag) {
                models.push(value.model);
              }
            }
          });
          models.sort();
          var modelhtml =
            '<option value="Select Model" disabled>Select Model</option>';
          for (var i = 0; i < models.length; i++) {
            var mo = models[i];
            var selected = "";
            if (mo.toUpperCase() == modeltag) {
              selected = "selected";
            }
            modelhtml =
              modelhtml +
              `<option value='${mo.replace(".", "")}' ${selected}>${
                mo.split("_")[1]
              }</option>`;
          }
          $(this2).find(".modelselect").html(modelhtml);
          $(this2).find(".modelselect").removeAttr("disabled");

          var years = [];

          var datasearch = {};

          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.year, years) === -1) {
              if (
                value.make.toUpperCase() == maketag &&
                value.model.toUpperCase() == modeltag
              ) {
                years.push(value.year);
                datasearch = value;
              }
            }
          });

          years.sort();
          years.reverse();

          var yearhtml =
            '<option value="Select Year" disabled selected>Select Year</option>';
          for (var i = 0; i < years.length; i++) {
            var ye = years[i];
            yearhtml =
              yearhtml +
              `<option value='${ye.replace(".", "")}'>${
                ye.split("_")[1]
              }</option>`;
          }
          $(this2).find(".yearselect").html(yearhtml);
          $(this2).find(".yearselect").removeAttr("disabled");

          $(this2).find(".makeselect").change(function () {
            namestr = $(this).val().split("_")[1];
            $(this2).find(".makeselect").val($(this).val());
            var models = [];
            var selmake = $(this).val();
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.model, models) === -1) {
                if (value.make == selmake) {
                  models.push(value.model);
                  datasearch = value;
                }
              }
            });
            models.sort();
            var modelhtml =
              '<option value="Select Model" disabled selected>Select Model</option>';
            for (var i = 0; i < models.length; i++) {
              var mo = models[i];
              var valmo = mo.replace(".", "");
              valmo = valmo.replace("'", "");
              valmo = valmo.replace('"', "");
              modelhtml =
                modelhtml +
                `<option value='${valmo}'>${mo.split("_")[1]}</option>`;
            }
            $(this2).find(".modelselect").html(modelhtml);
            $(this2).find(".modelselect").removeAttr("disabled");
            var yearhtml =
              '<option value="Select Year" disabled selected>Select Year</option>';
            $(this2).find(".yearselect").html(yearhtml);
            $(this2).find(".yearselect").attr("disabled", true);
          });

          $(this2).find(".modelselect").change(function () {
            $(this2).find(".modelselect").val($(this).val());
            var years = [];

            var datasearch = {};
            var selmake = $(this)
              .parents(".select-wrapper")
              .find(".makeselect")
              .val();
            var selmodel = $(this).val();
            namestr = selmake.split("_")[1] + " " + $(this).val().split("_")[1];
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.year, years) === -1) {
                if (
                  value.make.toUpperCase() == selmake.toUpperCase() &&
                  value.model.toUpperCase() == selmodel.toUpperCase()
                ) {
                  years.push(value.year);
                  datasearch = value;
                }
              }
            });

            years.sort();
            years.reverse();

            var yearhtml =
              '<option value="Select Year" disabled selected>Select Year</option>';
            for (var i = 0; i < years.length; i++) {
              var ye = years[i];
              yearhtml =
                yearhtml +
                `<option value='${ye.replace(".", "")}'>${
                  ye.split("_")[1]
                }</option>`;
            }
            $(this2).find(".yearselect").html(yearhtml);
            $(this2).find(".yearselect").removeAttr("disabled");
          });

          $(this2).find(".yearselect").change(function () {
            $(this2).find(".yearselect").val($(this).val());
            var yearc = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val()
              .replace(".", "")
              .replace("&", "%26");
            var makec = $(this)
              .parents(".select-wrapper")
              .find(".makeselect")
              .val()
              .replace(".", "")
              .replace("&", "%26");
            makec = makec.replace("/", "-");
            var modelc = $(this)
              .parents(".select-wrapper")
              .find(".modelselect")
              .val()
              .replace(".", "")
              .replace("&", "%26");
            var smodelc = modelc.split("/").join("-");
            var strpartn =
              yearc +
              "+" +
              makec +
              "+" +
              smodelc;

            var redurl =
              "/collections/" +
              handle +
              "?year=" +
              yearc.split("_")[1] +
              "&make=" +
              makec.split("_")[1] +
              "&model=" +
              modelc.split("_")[1];
            localStorage.clear();
            window.location.href = redurl;
          });
        }

        if (hasyear == true && hasmodel == true) {
          namestr = urlParams.get("year") + " " + urlParams.get("model");
          $(".yearselectbox").css("order", 1);
          $(".modelselectbox").css("order", 2);
          $(".makeselectbox").css("order", 3);

          var yeartag = "YEAR_" + urlParams.get("year").toUpperCase();
          var modeltag = "MODEL_" + urlParams.get("model").toUpperCase();

          var years = [];
          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.year, years) === -1) {
              years.push(value.year);
            }
          });

          years.sort();
          years.reverse();
          var stryear =
            '<option value="Select Year" disabled>Select Year</option>';
          for (var i = 0; i < years.length; i++) {
            var yy = years[i];
            var selected = "";
            if (yy.toUpperCase() == yeartag) {
              selected = "selected";
            }
            stryear =
              stryear +
              `<option value='${yy}' ${selected}>${yy.split("_")[1]}</option>`;
          }
          $(this2).find(".yearselect").html(stryear);
          $(this2).find(".yearselect").removeAttr("disabled");

          var models = [];

          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.model, models) === -1) {
              if (value.year.toUpperCase() == yeartag) {
                models.push(value.model);
              }
            }
          });
          models.sort();
          var modelhtml =
            '<option value="Select Model" disabled >Select Model</option>';
          for (var i = 0; i < models.length; i++) {
            var mo = models[i];
            var selected = "";
            if (mo.toUpperCase() == modeltag) {
              selected = "selected";
            }
            modelhtml =
              modelhtml +
              `<option value='${mo.replace(".", "")}' ${selected}>${
                mo.split("_")[1]
              }</option>`;
          }
          $(this2).find(".modelselect").html(modelhtml);
          $(this2).find(".modelselect").removeAttr("disabled");

          $(this2).find(".yearselect").change(function () {
            namestr = $(this).val().split("_")[1];
            $(this2).find(".yearselect").val($(this).val());
            var models = [];
            var selyear = $(this).val();
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.model, models) === -1) {
                if (value.year == selyear) {
                  models.push(value.model);
                  datasearch = value;
                }
              }
            });
            models.sort();
            var modelhtml =
              '<option value="Select Model" disabled selected>Select Model</option>';
            for (var i = 0; i < models.length; i++) {
              var mo = models[i];
              var valmo = mo.replace(".", "");
              valmo = valmo.replace("'", "");
              valmo = valmo.replace('"', "");
              modelhtml =
                modelhtml +
                `<option value='${valmo}'>${mo.split("_")[1]}</option>`;
            }
            $(this2).find(".modelselect").html(modelhtml);
            $(this2).find(".modelselect").removeAttr("disabled");
            var makehtml =
              '<option value="Select Make" disabled selected>Select Make</option>';
            $(this2).find(".makeselect").html(makehtml);
            $(this2).find(".makeselect").attr("disabled", true);
          });

          $(this2).find(".modelselect").change(function () {
            $(this2).find(".modelselect").val($(this).val());
            var makes = [];

            var datasearch = {};
            var selyear = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val();
            var selmodel = $(this).val();
            namestr = selyear.split("_")[1] + " " + $(this).val().split("_")[1];
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.make, makes) === -1) {
                if (
                  value.year.toUpperCase() == selyear.toUpperCase() &&
                  value.model.toUpperCase() == selmodel.toUpperCase()
                ) {
                  makes.push(value.make);
                  datasearch = value;
                }
              }
            });

            makes.sort();

            var makehtml =
              '<option value="Select Make" disabled selected>Select Make</option>';
            for (var i = 0; i < makes.length; i++) {
              var ma = makes[i];
              makehtml =
                makehtml +
                `<option value='${ma.replace(".", "")}'>${
                  ma.split("_")[1]
                }</option>`;
            }
            $(this2).find(".makeselect").html(makehtml);
            $(this2).find(".makeselect").removeAttr("disabled");
          });

          var makes = [];

          var datasearch = {};

          var found = false;

          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.make, makes) === -1) {
              if (
                value.year.toUpperCase() == yeartag &&
                value.model.toUpperCase() == modeltag
              ) {
                makes.push(value.make);
                datasearch = value;
                found = true;
              }
            }
          });

          makes.sort();

          var makehtml =
            '<option value="Select Make" disabled selected>Select Make</option>';
          for (var i = 0; i < makes.length; i++) {
            var ma = makes[i];
            makehtml =
              makehtml +
              `<option value='${ma.replace(".", "")}'>${
                ma.split("_")[1]
              }</option>`;
          }
          $(this2).find(".makeselect").html(makehtml);
          $(this2).find(".makeselect").removeAttr("disabled");

          $(this2).find(".makeselect").change(function () {
            $(this2).find(".makeselect").val($(this).val());
            var yearc = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val()
              .replace(".", "")
              .replace("&", "%26");
            var makec = $(this)
              .parents(".select-wrapper")
              .find(".makeselect")
              .val()
              .replace(".", "")
              .replace("&", "%26");
            makec = makec.replace("/", "-");
            var modelc = $(this)
              .parents(".select-wrapper")
              .find(".modelselect")
              .val()
              .replace(".", "")
              .replace("&", "%26");
            var smodelc = modelc.split("/").join("-");
            var strpartn =
              yearc+
              "+" +
              makec +
              "+" +
              smodelc;

            var redurl =
              "/collections/" +
              handle +
              "?year=" +
              yearc.split("_")[1] +
              "&make=" +
              makec.split("_")[1] +
              "&model=" +
              modelc.split("_")[1];
            localStorage.clear();
            window.location.href = redurl;
          });
        }

        if (hasyear == true && hasmake == true) {
          namestr = urlParams.get("year") + " " + urlParams.get("make");
          $(".yearselectbox").css("order", 1);
          $(".makeselectbox").css("order", 2);
          $(".modelselectbox").css("order", 3);

          var yeartag = "YEAR_" + urlParams.get("year").toUpperCase();
          var maketag = "MAKE_" + urlParams.get("make").toUpperCase();

          var years = [];
          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.year, years) === -1) {
              years.push(value.year);
            }
          });

          years.sort();
          years.reverse();
          var stryear =
            '<option value="Select Year" disabled>Select Year</option>';
          for (var i = 0; i < years.length; i++) {
            var yy = years[i];
            var selected = "";
            if (yy.toUpperCase() == yeartag) {
              selected = "selected";
            }
            stryear =
              stryear +
              `<option value='${yy}' ${selected}>${yy.split("_")[1]}</option>`;
          }
          $(this2).find(".yearselect").html(stryear);
          $(this2).find(".yearselect").removeAttr("disabled");

          var makes = [];

          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.make, makes) === -1) {
              if (value.year.toUpperCase() == yeartag) {
                makes.push(value.make);
              }
            }
          });
          makes.sort();
          var makehtml =
            '<option value="Select Make" disabled >Select Make</option>';
          for (var i = 0; i < makes.length; i++) {
            var ma = makes[i];
            var selected = "";
            if (ma.toUpperCase() == maketag) {
              selected = "selected";
            }
            makehtml =
              makehtml +
              `<option value='${ma.replace(".", "")}' ${selected}>${
                ma.split("_")[1]
              }</option>`;
          }
          $(this2).find(".makeselect").html(makehtml);
          $(this2).find(".makeselect").removeAttr("disabled");

          $(this2).find(".yearselect").change(function () {
            namestr = $(this).val().split("_")[1];
            $(this2).find(".yearselect").val($(this).val());
            var makes = [];

            var datasearch = {};
            var selyear = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val();

            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.make, makes) === -1) {
                if (value.year.toUpperCase() == selyear.toUpperCase()) {
                  makes.push(value.make);
                  datasearch = value;
                }
              }
            });

            makes.sort();

            var makehtml =
              '<option value="Select Make" disabled selected>Select Make</option>';
            for (var i = 0; i < makes.length; i++) {
              var ma = makes[i];
              makehtml =
                makehtml +
                `<option value='${ma.replace(".", "")}'>${
                  ma.split("_")[1]
                }</option>`;
            }
            $(this2).find(".makeselect").html(makehtml);
            $(this2).find(".makeselect").removeAttr("disabled");
            var modelhtml =
              '<option value="Select Model" disabled selected>Select Model</option>';
            $(this2).find(".modelselect").html(modelhtml);
            $(this2).find(".modelselect").attr("disabled", true);
          });

          $(this2).find(".makeselect").change(function () {
            $(this2).find(".makeselect").val($(this).val());
            var models = [];
            var selyear = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val();
            var selmake = $(this).val();
            namestr = selyear.split("_")[1] + " " + $(this).val().split("_")[1];
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.model, models) === -1) {
                if (value.year == selyear && value.make == selmake) {
                  models.push(value.model);
                  datasearch = value;
                }
              }
            });
            models.sort();
            var modelhtml =
              '<option value="Select Model" disabled selected>Select Model</option>';
            for (var i = 0; i < models.length; i++) {
              var mo = models[i];
              var valmo = mo.replace(".", "");
              valmo = valmo.replace("'", "");
              valmo = valmo.replace('"', "");
              modelhtml =
                modelhtml +
                `<option value='${valmo}'>${mo.split("_")[1]}</option>`;
            }
            $(this2).find(".modelselect").html(modelhtml);
            $(this2).find(".modelselect").removeAttr("disabled");
          });

          var models = [];

          var datasearch = {};

          var found = false;

          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.model, models) === -1) {
              if (
                value.year.toUpperCase() == yeartag &&
                value.make.toUpperCase() == maketag
              ) {
                models.push(value.model);
                datasearch = value;
                found = true;
              }
            }
          });

          models.sort();

          var modelhtml =
            '<option value="Select Model" disabled selected>Select Model</option>';
          for (var i = 0; i < models.length; i++) {
            var mo = models[i];
            modelhtml =
              modelhtml +
              `<option value='${mo.replace(".", "")}'>${
                mo.split("_")[1]
              }</option>`;
          }
          $(this2).find(".modelselect").html(modelhtml);
          $(this2).find(".modelselect").removeAttr("disabled");

          $(this2).find(".modelselect").change(function () {
            $(this2).find(".modelselect").val($(this).val());
            var yearc = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val()
              .replace(".", "")
              .replace("&", "%26");
            var makec = $(this)
              .parents(".select-wrapper")
              .find(".makeselect")
              .val()
              .replace(".", "")
              .replace("&", "%26");
            makec = makec.replace("/", "-");
            var modelc = $(this)
              .parents(".select-wrapper")
              .find(".modelselect")
              .val()
              .replace(".", "")
              .replace("&", "%26");
            var smodelc = modelc.split("/").join("-");
            var strpartn =
              yearc +
              "+" +
              makec +
              "+" +
              smodelc;

            var redurl =
              "/collections/" +
              handle +
              "?year=" +
              yearc.split("_")[1] +
              "&make=" +
              makec.split("_")[1] +
              "&model=" +
              modelc.split("_")[1];
            localStorage.clear();
            window.location.href = redurl;
          });
        }

        if (hasyear == false && hasmodel == false && hasmake == false) {
          namestr = maintitle;
          $(".yearselectbox").css("order", 1);
          $(".makeselectbox").css("order", 2);
          $(".modelselectbox").css("order", 3);

          var datasearch = jsonarr[0];
          var years = [];
          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.year, years) === -1) {
              years.push(value.year);
            }
          });
          years.sort();
          years.reverse();
          var stryear =
            '<option value="Select Year" disabled selected>Select Year</option>';
          for (var i = 0; i < years.length; i++) {
            var yy = years[i];
            stryear =
              stryear + `<option value='${yy}'>${yy.split("_")[1]}</option>`;
          }
          $(this2).find(".yearselect").html(stryear);
          $(this2).find(".yearselect").removeAttr("disabled");
          $(this2).find(".yearselect").change(function () {
            $(this2).find(".yearselect").val($(this).val());
            $(".amfinder-reset").show();

            $(this2).find(".modelselect").html(
              '<option value="Please Select" disabled selected>Loading..</option>'
            );
            $(this2).find(".makeselect").html(
              '<option value="Please Select" disabled selected>Loading..</option>'
            );

            var makes = [];
            var selyear = $(this).val();
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.make, makes) === -1) {
                if (value.year == selyear) {
                  makes.push(value.make);
                }
              }
            });
            makes.sort();
            var strmake =
              '<option value="Select Make" disabled selected>Select Make</option>';
            for (var i = 0; i < makes.length; i++) {
              var ma = makes[i];
              var valma = ma.replace(".", "");
              valma = valma.replace("'", "");
              valma = valma.replace('"', "");
              strmake =
                strmake +
                `<option value='${valma}'>${ma.split("_")[1]}</option>`;
            }
            $(this2).find(".makeselect").html(strmake);
            $(this2).find(".makeselect").removeAttr("disabled");
            $(this2).find(".modelselect").html(
              '<option value="Select Model" disabled selected>Select Model</option>'
            );
            $(this2).find(".modelselect").attr("disabled", true);
          });
          $(this2).find(".makeselect").change(function () {
            $(this2).find(".makeselect").val($(this).val());
            $(".amfinder-reset").show();

            var models = [];
            var selyear = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val();
            var selmake = $(this).val();
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.model, models) === -1) {
                if (value.year == selyear && value.make == selmake) {
                  models.push(value.model);
                }
              }
            });
            models.sort();
            var modelhtml =
              '<option value="Select Model" disabled selected>Select Model</option>';
            for (var i = 0; i < models.length; i++) {
              var mo = models[i];
              var valmo = mo.replace(".", "");
              valmo = valmo.replace("'", "");
              valmo = valmo.replace('"', "");
              modelhtml =
                modelhtml +
                `<option value='${valmo}'>${mo.split("_")[1]}</option>`;
            }
            $(this2).find(".modelselect").html(modelhtml);
            $(this2).find(".modelselect").removeAttr("disabled");
          });

          $(this2).find(".modelselect").change(function () {
            $(this2).find(".modelselect").val($(this).val());
            $(".search--button").removeAttr("disabled");
          });

          //$(".search--button").click(function ()
          $(this2).find(".modelselect").change(function () {
            $(this2).find(".modelselect").val($(this).val());
            var yearc = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val()
              .replace(".", "")
              .replace("&", "%26");
            var makec = $(this)
              .parents(".select-wrapper")
              .find(".makeselect")
              .val()
              .replace(".", "")
              .replace("&", "%26");
            makec = makec.replace("/", "-");
            var modelc = $(this)
              .parents(".select-wrapper")
              .find(".modelselect")
              .val()
              .replace(".", "")
              .replace("&", "%26");
            var smodelc = modelc.split("/").join("-");
            var redurl =
              "/collections/" +
              handle +
              "?year=" +
              yearc.split("_")[1] +
              "&make=" +
              makec.split("_")[1] +
              "&model=" +
              modelc.split("_")[1];

            localStorage.clear();
            window.location.href = redurl;
          });
        }

        if (hasyear == true && hasmodel == false && hasmake == false) {
          namestr = maintitle;
          $(".yearselectbox").css("order", 1);
          $(".makeselectbox").css("order", 2);
          $(".modelselectbox").css("order", 3);

          var yeartag = "YEAR_" + urlParams.get("year").toUpperCase();

          var found = false;
          var datasearch = {};
          var years = [];
          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.year, years) === -1) {
              years.push(value.year);
            }
          });

          years.sort();
          years.reverse();
          var stryear =
            '<option value="Select Year" disabled>Select Year</option>';
          for (var i = 0; i < years.length; i++) {
            var yy = years[i];
            var selected = "";
            if (yy.toUpperCase() == yeartag) {
              selected = "selected";
            }
            stryear =
              stryear +
              `<option value='${yy}' ${selected}>${yy.split("_")[1]}</option>`;
          }
          $(this2).find(".yearselect").html(stryear);
          $(this2).find(".yearselect").removeAttr("disabled");

          $(this2).find(".modelselect").html(
            '<option value="Please Select" disabled selected>Loading..</option>'
          );
          $(this2).find(".makeselect").html(
            '<option value="Please Select" disabled selected>Loading..</option>'
          );

          var makes = [];
          var selyear = yeartag;
          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.make, makes) === -1) {
              if (value.year == selyear) {
                makes.push(value.make);
                if (found == false) {
                  datasearch = value;
                  found = true;
                }
              }
            }
          });
          makes.sort();
          var strmake =
            '<option value="Select Make" disabled selected>Select Make</option>';
          for (var i = 0; i < makes.length; i++) {
            var ma = makes[i];
            var valma = ma.replace(".", "");
            valma = valma.replace("'", "");
            valma = valma.replace('"', "");
            strmake =
              strmake + `<option value='${valma}'>${ma.split("_")[1]}</option>`;
          }
          $(this2).find(".makeselect").html(strmake);
          $(this2).find(".makeselect").removeAttr("disabled");
          $(this2).find(".modelselect").html(
            '<option value="Select Model" disabled selected>Select Model</option>'
          );
          $(this2).find(".modelselect").attr("disabled", true);

          $(this2).find(".yearselect").change(function () {
            namestr = $(this).val().split("_")[1];
            $(this2).find(".yearselect").val($(this).val());
            var makes = [];

            var datasearch = {};
            var selyear = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val();

            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.make, makes) === -1) {
                if (value.year.toUpperCase() == selyear.toUpperCase()) {
                  makes.push(value.make);
                  datasearch = value;
                }
              }
            });

            makes.sort();

            var makehtml =
              '<option value="Select Make" disabled selected>Select Make</option>';
            for (var i = 0; i < makes.length; i++) {
              var ma = makes[i];
              makehtml =
                makehtml +
                `<option value='${ma.replace(".", "")}'>${
                  ma.split("_")[1]
                }</option>`;
            }
            $(this2).find(".makeselect").html(makehtml);
            $(this2).find(".makeselect").removeAttr("disabled");
            var modelhtml =
              '<option value="Select Model" disabled selected>Select Model</option>';
            $(this2).find(".modelselect").html(modelhtml);
            $(this2).find(".modelselect").attr("disabled", true);
          });

          $(this2).find(".makeselect").change(function () {
            $(this2).find(".makeselect").val($(this).val());
            $(".amfinder-reset").show();
            var models = [];
            var selyear = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val();
            var selmake = $(this).val();
            namestr = selyear.split("_")[1] + " " + $(this).val().split("_")[1];
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.model, models) === -1) {
                if (value.year == selyear && value.make == selmake) {
                  models.push(value.model);
                  datasearch = value;
                }
              }
            });
            models.sort();
            var modelhtml =
              '<option value="Select Model" disabled selected>Select Model</option>';
            for (var i = 0; i < models.length; i++) {
              var mo = models[i];
              var valmo = mo.replace(".", "");
              valmo = valmo.replace("'", "");
              valmo = valmo.replace('"', "");
              modelhtml =
                modelhtml +
                `<option value='${valmo}'>${mo.split("_")[1]}</option>`;
            }
            $(this2).find(".modelselect").html(modelhtml);
            $(this2).find(".modelselect").removeAttr("disabled");
          });

          $(this2).find(".modelselect").change(function () {
            $(this2).find(".modelselect").val($(this).val());
            $(".search--button").removeAttr("disabled");
          });

          $(this2).find(".modelselect").change(function () {
            $(this2).find(".modelselect").val($(this).val());
            var yearc = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val()
              .replace(".", "")
              .replace("&", "%26");
            var makec = $(this)
              .parents(".select-wrapper")
              .find(".makeselect")
              .val()
              .replace(".", "")
              .replace("&", "%26");
            makec = makec.replace("/", "-");
            var modelc = $(this)
              .parents(".select-wrapper")
              .find(".modelselect")
              .val()
              .replace(".", "")
              .replace("&", "%26");
            var smodelc = modelc.split("/").join("-");
            var redurl =
              "/collections/" +
              handle +
              "?year=" +
              yearc.split("_")[1] +
              "&make=" +
              makec.split("_")[1] +
              "&model=" +
              modelc.split("_")[1];

            localStorage.clear();
            window.location.href = redurl;
          });
        }

        if (hasyear == false && hasmodel == true && hasmake == false) {
          namestr = urlParams.get("model");
          $(".makeselectbox").css("order", 2);
          $(".modelselectbox").css("order", 1);
          $(".yearselectbox").css("order", 3);

          var modeltag = "MODEL_" + urlParams.get("model").toUpperCase();

          var models = [];

          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.model, models) === -1) {
              models.push(value.model);
            }
          });
          models.sort();
          var modelhtml =
            '<option value="Select Model" disabled >Select Model</option>';
          for (var i = 0; i < models.length; i++) {
            var mo = models[i];
            var selected = "";
            if (mo.toUpperCase() == modeltag) {
              selected = "selected";
            }
            modelhtml =
              modelhtml +
              `<option value='${mo.replace(".", "")}' ${selected}>${
                mo.split("_")[1]
              }</option>`;
          }
          $(this2).find(".modelselect").html(modelhtml);
          $(this2).find(".modelselect").removeAttr("disabled");

          var makes = [];

          var datasearch = {};

          var found = false;

          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.make, makes) === -1) {
              if (value.model.toUpperCase() == modeltag) {
                makes.push(value.make);
                if (found == false) {
                  datasearch = value;
                  found = true;
                }
              }
            }
          });

          makes.sort();

          var makehtml =
            '<option value="Select Make" disabled selected>Select Make</option>';
          for (var i = 0; i < makes.length; i++) {
            var ma = makes[i];
            makehtml =
              makehtml +
              `<option value='${ma.replace(".", "")}'>${
                ma.split("_")[1]
              }</option>`;
          }
          $(this2).find(".makeselect").html(makehtml);
          $(this2).find(".makeselect").removeAttr("disabled");

          $(this2).find(".yearselect").html(
            '<option value="Select Year" disabled selected>Select Year</option>'
          );
          $(this2).find(".yearselect").attr("disabled", true);

          $(this2).find(".modelselect").change(function () {
            $(this2).find(".modelselect").val($(this).val());
            var makes = [];

            var datasearch = {};

            var selmodel = $(this).val();
            namestr = $(this).val().split("_")[1];
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.make, makes) === -1) {
                if (value.model.toUpperCase() == selmodel.toUpperCase()) {
                  makes.push(value.make);
                  datasearch = value;
                }
              }
            });

            makes.sort();

            var makehtml =
              '<option value="Select Make" disabled selected>Select Make</option>';
            for (var i = 0; i < makes.length; i++) {
              var ma = makes[i];
              makehtml =
                makehtml +
                `<option value='${ma.replace(".", "")}'>${
                  ma.split("_")[1]
                }</option>`;
            }
            $(this2).find(".makeselect").html(makehtml);
            $(this2).find(".makeselect").removeAttr("disabled");
            var yearhtml =
              '<option value="Select Year" disabled selected>Select Year</option>';
            $(this2).find(".yearselect").html(yearhtml);
            $(this2).find(".yearselect").attr("disabled", true);
          });

          $(this2).find(".makeselect").change(function () {
            $(this2).find(".makeselect").val($(this).val());
            $(".amfinder-reset").show();
            var years = [];
            var selmodel = $(this)
              .parents(".select-wrapper")
              .find(".modelselect")
              .val();
            var selmake = $(this).val();
            namestr =
              $(this).val().split("_")[1] + " " + modeltag.split("_")[1];
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.year, years) === -1) {
                if (
                  value.model.toUpperCase() == selmodel.toUpperCase() &&
                  value.make.toUpperCase() == selmake.toUpperCase()
                ) {
                  years.push(value.year);
                  datasearch = value;
                }
              }
            });
            years.sort();
            years.reverse();
            var yearhtml =
              '<option value="Select Year" disabled selected>Select Year</option>';
            for (var i = 0; i < years.length; i++) {
              var ye = years[i];
              var valyear = ye.replace(".", "");
              valyear = valyear.replace("'", "");
              valyear = valyear.replace('"', "");
              yearhtml =
                yearhtml +
                `<option value='${valyear}'>${ye.split("_")[1]}</option>`;
            }
            $(this2).find(".yearselect").html(yearhtml);
            $(this2).find(".yearselect").removeAttr("disabled");
          });

          $(this2).find(".yearselect").change(function () {
            $(this2).find(".yearselect").val($(this).val());
            var yearc = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val()
              .replace(".", "")
              .replace("&", "%26");
            var makec = $(this)
              .parents(".select-wrapper")
              .find(".makeselect")
              .val()
              .replace(".", "")
              .replace("&", "%26");
            makec = makec.replace("/", "-");
            var modelc = $(this)
              .parents(".select-wrapper")
              .find(".modelselect")
              .val()
              .replace(".", "")
              .replace("&", "%26");
            var smodelc = modelc.split("/").join("-");
            var redurl =
              "/collections/" +
              handle +
              "?year=" +
              yearc.split("_")[1] +
              "&make=" +
              makec.split("_")[1] +
              "&model=" +
              modelc.split("_")[1];

            localStorage.clear();
            window.location.href = redurl;
          });
        }

        if (hasyear == false && hasmodel == false && hasmake == true) {
          namestr = urlParams.get("make");
          $(".makeselectbox").css("order", 1);
          $(".modelselectbox").css("order", 2);
          $(".yearselectbox").css("order", 3);

          var maketag = "MAKE_" + urlParams.get("make").toUpperCase();

          var makes = [];

          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.make, makes) === -1) {
              makes.push(value.make);
            }
          });
          makes.sort();
          var strmake =
            '<option value="Select Make" disabled>Select Make</option>';
          for (var i = 0; i < makes.length; i++) {
            var ma = makes[i];
            var selected = "";
            if (ma.toUpperCase() == maketag) {
              selected = "selected";
            }
            strmake =
              strmake +
              `<option value='${ma.replace(".", "")}' ${selected}>${
                ma.split("_")[1]
              }</option>`;
          }
          $(this2).find(".makeselect").html(strmake);
          $(this2).find(".makeselect").removeAttr("disabled");

          var models = [];

          var datasearch = {};

          var found = false;

          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.model, models) === -1) {
              if (value.make.toUpperCase() == maketag) {
                models.push(value.model);
                if (found == false) {
                  datasearch = value;
                  found = true;
                }
              }
            }
          });

          models.sort();

          var modelhtml =
            '<option value="Select Model" disabled selected>Select Model</option>';
          for (var i = 0; i < models.length; i++) {
            var mo = models[i];
            modelhtml =
              modelhtml +
              `<option value='${mo.replace(".", "")}'>${
                mo.split("_")[1]
              }</option>`;
          }
          $(this2).find(".modelselect").html(modelhtml);
          $(this2).find(".modelselect").removeAttr("disabled");

          $(this2).find(".yearselect").html(
            '<option value="Select Year" disabled selected>Select Year</option>'
          );
          $(this2).find(".yearselect").attr("disabled", true);

          $(this2).find(".makeselect").change(function () {
            namestr = $(this).val().split("_")[1];
            $(this2).find(".makeselect").val($(this).val());
            var models = [];
            var selmake = $(this).val();
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.model, models) === -1) {
                if (value.make == selmake) {
                  models.push(value.model);
                  datasearch = value;
                }
              }
            });
            models.sort();
            var modelhtml =
              '<option value="Select Model" disabled selected>Select Model</option>';
            for (var i = 0; i < models.length; i++) {
              var mo = models[i];
              var valmo = mo.replace(".", "");
              valmo = valmo.replace("'", "");
              valmo = valmo.replace('"', "");
              modelhtml =
                modelhtml +
                `<option value='${valmo}'>${mo.split("_")[1]}</option>`;
            }
            $(this2).find(".modelselect").html(modelhtml);
            $(this2).find(".modelselect").removeAttr("disabled");
            var yearhtml =
              '<option value="Select Year" disabled selected>Select Year</option>';
            $(this2).find(".yearselect").html(yearhtml);
            $(this2).find(".yearselect").attr("disabled", true);
          });

          $(this2).find(".modelselect").change(function () {
            $(this2).find(".modelselect").val($(this).val());
            $(".amfinder-reset").show();

            var years = [];
            var selmodel = $(this).val().toUpperCase();
            var selmake = $(this)
              .parents(".select-wrapper")
              .find(".makeselect")
              .val();
            namestr = maketag.split("_")[1] + " " + $(this).val().split("_")[1];
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.year, years) === -1) {
                if (
                  value.model.toUpperCase() == selmodel &&
                  value.make.toUpperCase() == selmake.toUpperCase()
                ) {
                  years.push(value.year);
                  datasearch = value;
                }
              }
            });

            years.sort();
            years.reverse();
            var yearhtml =
              '<option value="Select Year" disabled selected>Select Year</option>';
            for (var i = 0; i < years.length; i++) {
              var ye = years[i];
              var valyear = ye.replace(".", "");
              valyear = valyear.replace("'", "");
              valyear = valyear.replace('"', "");
              yearhtml =
                yearhtml +
                `<option value='${valyear}'>${ye.split("_")[1]}</option>`;
            }
            $(this2).find(".yearselect").html(yearhtml);
            $(this2).find(".yearselect").removeAttr("disabled");
          });

          $(this2).find(".yearselect").change(function () {
            $(this2).find(".yearselect").val($(this).val());
            var yearc = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val()
              .replace(".", "")
              .replace("&", "%26");
            var makec = $(this)
              .parents(".select-wrapper")
              .find(".makeselect")
              .val()
              .replace(".", "")
              .replace("&", "%26");
            makec = makec.replace("/", "-");
            var modelc = $(this)
              .parents(".select-wrapper")
              .find(".modelselect")
              .val()
              .replace(".", "")
              .replace("&", "%26");
            var smodelc = modelc.split("/").join("-");
            var redurl =
              "/collections/" +
              handle +
              "?year=" +
              yearc.split("_")[1] +
              "&make=" +
              makec.split("_")[1] +
              "&model=" +
              modelc.split("_")[1];

            localStorage.clear();
            window.location.href = redurl;
          });
        }

        if (hasyear == true && hasmodel == true && hasmake == true) {
          namestr =
            urlParams.get("year") +
            " " +
            urlParams.get("make") +
            " " +
            urlParams.get("model");
          var redurl =
            "/collections/" +
            handle +
            "?year=" +
            urlParams.get("year") +
            "&make=" +
            urlParams.get("make") +
            "&model=" +
            urlParams.get("model");

          localStorage.clear();
          window.location.href = redurl;
        }
      }
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("main-product-mockup", mainproductmockup);


// document.querySelectorAll('a[href^="#"]').forEach(anchor => {
//     anchor.addEventListener('click', function (e) {
//         e.preventDefault();

//         document.querySelector(this.getAttribute('href')).scrollIntoView({
//             behavior: 'smooth'
//         });
//     });
// });

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        const targetElement = document.querySelector(this.getAttribute('href'));
        const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
        const startPosition = window.pageYOffset;
        const distance = targetPosition - startPosition;
        const duration = 800;
        let start = null;

        function step(timestamp) {
            if (!start) start = timestamp;
            const progress = timestamp - start;
            const percent = Math.min(progress / duration, 1);
            window.scrollTo(0, startPosition + distance * percent);
            if (progress < duration) {
                requestAnimationFrame(step);
            }
        }

        requestAnimationFrame(step);
    });
});

document.addEventListener("click", function (e) {
  const link = e.target.closest(
    '#shop-by-type a.collection-container'
  );
  if (!link) return;
  fireAdRollSegment("9cb5aecd");
});
